<template>

  <div id="dlnkaap_candidature">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="bg-primary" style="background-image: url('/themes/template/img/components/abstract-shapes-20.svg')">
      <div class="space-1 space-top-lg-2 space-bottom-lg-3">
        <div class="row align-items-center">
          <div class="col">
            <div class="d-flex justify-content-between">
              <div class="d-none d-md-block">
                <h1 class="h2 text-white">Formulaire- {{ step }}</h1>
              </div>
              <a class="btn btn-info d-flex" href="./liste_reponses_porteur" role="button">
                <i class="align-self-center font-size-2" style="font-style: normal;">Liste des candidatures</i>
              </a>
            </div>

            <!--
            <div class="d-none d-md-block"><h3 class="text-white">Tous les champs sont obligatoires (sauf précisés)</h3>
            </div> 
            -->

            <div class="d-none d-md-block mt-4">
              <ul class="step step-centered step-md">
                <li class="step-item">
                  <a href="javascript:" @click="goto_step('structure')">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'structure') ? 'step-icon-info' : 'step-icon-soft-dark' ">1</span>
                      <div class="step-content">
                        <h4 class="text-white">Structure</h4>
                        <p class="step-text text-info"
                           v-bind:class="(step !== 'structure') ? 'd-none' : '' ">Informations générales sur votre
                          organisation</p></div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" @click="goto_step('projet')">
                    <div class="step-content-wrapper">
                      <span class="step-icon"
                            v-bind:class="(step === 'projet') ? 'step-icon-info' : 'step-icon-soft-dark' ">2</span>
                      <div class="step-content">
                        <h4 class="text-white">Projet</h4>
                        <p class="step-text text-secondary"
                           v-bind:class="(step !== 'projet') ? 'd-none' : '' ">Une description complète de votre projet,
                          le coeur de
                          votre réponse
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
                <li class="step-item">
                  <a href="javascript:" data-toggle="modal" data-target="#validation_formulaire">
                    <div class="step-content">
                      <span class="step-icon"
                            v-bind:class="(step === 'validation') ? 'step-icon-info' : 'step-icon-soft-dark' ">3</span>
                      <div class="step-content">
                        <h4 class="text-white">Validation</h4>
                        <p class="step-text text-secondary"
                           v-bind:class="(step !== 'validation') ? 'd-none' : '' ">Validation de votre participation</p>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="aap_form"
          enctype="multipart/form-data"
          method="post"
          @submit.prevent="post_structure">

      <div v-bind:class="class_content"
           class="space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">

        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Structure
                  </h3>
                  <a href="javascript:" class="btn btn-primary h-100" @click="post_structure()">Sauvegarder</a>
                </div>
              </div>
              <div>
                <div class="card-body">

                  <h4 class="mb-4">Axe du projet</h4>

                  <div class="row form-group">
                    <label for="axe" class="col-sm-3 col-form-label input-label">Axe</label>
                    <div data-progress="part2" class="col-sm-9">
                      <div class="input-group">
                        <select name="aap[axe]" id="axe" class="form-control" v-model="axe">
                          <option>Autonomie (Handicap et Senior)</option>
                          <option>Famille / Jeunesse</option>
                          <option>Insertion et action sociale</option>
                          <option>Logement et mixité sociale</option>
                          <option>Santé et petite enfance</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <h4 class="mb-4">Identité de la structure (ex : 80193184100028)</h4>

                  <div class="row form-group">
                    <label for="siret" class="col-sm-3 col-form-label input-label">SIRET</label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[siret]" id="siret" placeholder="123456789" aria-label="12345879"
                             class="form-control" @change="siret_info()" v-model="siret" required
                             :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}">
                      <div v-if="invalid_siret" class="text-danger">
                        Le numéro de SIRET est composé de 14 chiffres.
                      </div>
                    </div>
                  </div>

                  <div class="row form-group">
                    <label for="date_immatriculation" class="col-sm-3 col-form-label input-label">
                      Date d'immatriculation
                    </label>
                    <div class="col-sm-9">
                      <input type="date" name="aap[date_immatriculation]" id="date_immatriculation"
                             placeholder="Date d'immatriculation" aria-label="Date d'immatriculation"
                             :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                             class="form-control" v-model="date_immatriculation" required>
                    </div>
                  </div>

                  <!-- Structure name -->
                  <div class="row form-group">
                    <label for="nom" class="col-sm-3 col-form-label input-label">
                      Nom de la structure
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[nom]" id="nom" placeholder="Nom" aria-label="Nom"
                             :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                             class="form-control" v-model="nom" required>
                    </div>
                  </div>


                  <div class="row form-group"><label class="col-sm-3 col-form-label input-label">Logo de la
                    structure</label>
                    <div class="col-sm-9">
                      <div class="media align-items-center">


                        <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                data-toggle="tooltip" data-placement="top"
                                title="Logo de la structure">
                          <img
                              class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                              id="logo_structure"
                              :src="logo_structure"
                              alt="Votre avatar"/>
                          <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                            Ajouter / modifier la photo
                            <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                               data-target="#change_logo_structure">
                              <i class="fa fa-question-circle"></i>
                            </a>
                          </figcaption>
                        </figure>

                        <dlnk-clipper
                            modal_id="change_logo_structure"
                            @imgURL="set_logo_structure($event)"
                            :crop_ratio="1">
                        </dlnk-clipper>


                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <!-- Adresse -->
                    <div class="col-4">
                      <label for="adresse" class="input-label">Numéro et rue</label>
                      <div class="col-sm-9 mw-100 px-0">
                        <input type="text" name="aap[adresse]" id="adresse" placeholder="Numéro et rue"
                               :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                               aria-label="Numéro et rue" class="form-control" v-model="adresse">
                      </div>
                    </div>

                    <!-- Code postal -->
                    <div class="col-4">
                      <label for="code_postal" class="input-label">Code postal</label>
                      <div class="col-sm-9 mw-100 px-0">
                        <input type="text" name="aap[code_postal]" id="code_postal"
                               v-model="code_postal" placeholder="Code postal de la structure"
                               :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                               aria-label="Code postal de la structure" class="form-control">
                      </div>
                    </div>

                    <!-- Ville -->
                    <div class="col-4">
                      <label for="ville" class="input-label">Ville</label>
                      <div class="col-sm-9 mw-100 px-0">
                        <input type="text" name="aap[ville]" id="ville"
                               placeholder="Commune de la structure"
                               :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                               aria-label="Commune de la structure" class="form-control" v-model="ville">
                      </div>
                    </div>
                  </div>

                  <!-- Téléphone -->
                  <div class="row form-group">
                    <label for="telephone" class="col-sm-3 col-form-label input-label">Téléphone</label>
                    <div class="col-sm-9">
                      <input type="tel" name="aap[telephone]" id="telephone" placeholder="Téléphone"
                             :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                             aria-label="Téléphone" class="form-control" v-model="telephone">
                    </div>
                  </div>
                  <!-- Email -->
                  <div class="row form-group">
                    <label for="email" class="col-sm-3 col-form-label input-label">Email</label>
                    <div class="col-sm-9">
                      <input type="email" name="aap[email]" id="email" placeholder="Email"
                             :class="{'is-valid': valid_siret,'is-invalid': invalid_siret}"
                             aria-label="Email" class="form-control" v-model="email">
                    </div>
                  </div>
                  <!-- Structure website -->
                  <div class="row form-group">
                    <label for="site_web" class="col-sm-3 col-form-label input-label">
                      Site web de la structure
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[site_web]" id="site_web"
                             placeholder="https://votre_site.fr"
                             aria-label="http://votre_site.fr" class="form-control" v-model="site_web">
                    </div>
                  </div>
                  <!-- Structure legal notice -->
                  <div class="row form-group">
                    <label for="statut_juridique" class="col-sm-3 col-form-label input-label">
                      Statut juridique
                    </label>
                    <div class="col-sm-9">
                      <div class="input-group">
                        <select name="aap[statut_juridique]" id="statut_juridique" class="form-control"
                                v-model="statut_juridique">
                          <option>Association</option>
                          <option selected="selected">Collectivité territoriale</option>
                          <option>Établissement public</option>
                          <option>EPCI</option>
                          <option>Établissement scolaire</option>
                          <option>Entreprise</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div id="asso_details" class="collapse">
                    <div class="card card-body">
                      <!-- Structure - nom président asso -->
                      <div class="row form-group">
                        <label for="asso_president" class="col-sm-3 col-form-label input-label">
                          Nom du président
                        </label>
                        <div class="col-sm-9">
                          <input type="text" name="aap[asso_president]" id="asso_president"
                                 placeholder="Nom" aria-label="Nom" class="form-control" v-model="asso_president">
                        </div>
                      </div>
                      <h6>Adresse pour courriers de réponse</h6>

                      <!-- Structure - asso - adresse -->
                      <div class="row form-group">

                        <div class="col-4">
                          <label for="asso_adresse" class="input-label">Numéro et rue</label>
                          <div class="col-sm-9 mw-100 px-0">
                            <input type="text" name="aap[asso_adresse]" id="asso_adresse"
                                   placeholder="Numéro et rue" aria-label="Numéro et rue"
                                   class="form-control" v-model="asso_adresse">
                          </div>
                        </div>

                        <div class="col-4">
                          <label for="asso_code_postal" class="input-label">Code postal</label>
                          <div class="col-sm-9 mw-100 px-0">
                            <input type="text" name="aap[asso_code_postal]" id="asso_code_postal"
                                   placeholder="Code postal" aria-label="Code postal"
                                   class="form-control" v-model="asso_code_postal">
                          </div>
                        </div>
                        <div class="col-4">
                          <label for="asso_ville" class="input-label">Ville</label>
                          <div class="col-sm-9 mw-100 px-0">
                            <input type="text" name="aap[asso_ville]" id="asso_ville" placeholder="Ville"
                                   aria-label="Ville" class="form-control" v-model="asso_ville">
                          </div>
                        </div>
                      </div>

                      <div class="row form-group">
                        <label class="col-sm-3 col-form-label input-label">
                          Votre association est reconnue d'utilité publique ?
                        </label>
                        <div class="col-sm-9 my-auto">
                          <div class="form-check form-check-inline">
                            <input type="radio" name="aap[asso_utilite_public]"
                                   id="asso_utilite_public_oui"
                                   :checked="asso_utilite_public === true"
                                   class="form-check-input" value="1">
                            <label for="asso_utilite_public_oui" class="form-check-label">Oui</label>
                          </div>

                          <div class="form-check form-check-inline">
                            <input type="radio" name="aap[asso_utilite_public]"
                                   id="asso_utilite_public_non"
                                   :checked="asso_utilite_public === false"
                                   class="form-check-input" value="0">
                            <label for="asso_utilite_public_non" class="form-check-label">
                              Non
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="my-6 mw-66 mx-auto">

                  <h4 class="mb-4">Objet de la structure</h4>

                  <!-- Structure - objet - email -->
                  <div class="row form-group">
                    <label for="contact_email" class="col-sm-3 col-form-label input-label">
                      Email pour les correspondances
                    </label>
                    <div class="col-sm-9">
                      <input type="email" name="aap[contact_email]" id="contact_email"
                             placeholder="Email de contact"
                             aria-label="Email de contact" class="form-control" v-model="contact_email">
                    </div>
                  </div>

                  <!-- Structure - object - activity -->
                  <div class="row form-group">
                    <label for="activite_principale" class="col-sm-3 col-form-label input-label">
                      Activités principales / Historique
                    </label>
                    <div class="col-sm-9">
                      <textarea rows="3" name="aap[activite_principale]" id="activite_principale"
                                placeholder="Nous effectuons ..." aria-label="Nous effectuons ..." class="form-control"
                                v-model="activite_principale"></textarea>
                    </div>
                  </div>

                  <!-- Structure - object - size -->
                  <div class="row form-group">
                    <label for="taille_structure" class="col-sm-3 col-form-label input-label">
                      Taille de la structure
                    </label>
                    <div class="col-sm-9">
                      <input type="number" name="aap[taille_structure]" id="taille_structure"
                             min="0" step="1"
                             v-model="taille_structure" class="form-control"
                             placeholder="10 membres/salariés" aria-label="Nombre de membres/salariés">
                    </div>
                  </div>

                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">Salariés ?</label>
                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[salaries]" id="salaries_oui" class="form-check-input" value="1"
                               :checked="salaries === true">
                        <label for="salaries_oui" class="form-check-label">Oui</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[salaries]" id="salaries_non" checked="checked"
                               class="form-check-input" value="0"
                               :checked="salaries === false">
                        <label for="salaries_non" class="form-check-label">Non</label>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer d-flex justify-content-end">
                    <a href="javascript:" class="btn btn-primary" @click="post_structure()">Sauvegarder</a>
                    <a href="javascript:" class="btn btn-primary ml-2" @click="goto_step('projet')">Suivant</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div v-bind:class="(step === 'structure' || step === 'validation') ? 'd-none' : '' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">

        <div class="row">

          <div id="candidature_form_content" v-bind:class="aap.status_id == 9 ? 'col-lg-12 disabled' : 'col-lg-12'">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">
                    Projet
                  </h3>
                  <a v-if="aap.status_id != 9" href="javascript:" class="btn btn-primary h-100"
                     @click="post_structure()">Sauvegarder</a>
                </div>
              </div>

              <!-- Sticky progression -->
              <div id="stickyBlockStartPoint" style="z-index: 999;">
                <div data-hs-sticky-block-options="{
                                &quot;parentSelector&quot;: &quot;#stickyBlockStartPoint&quot;,
                                &quot;breakpoint&quot;: &quot;lg&quot;,
                                &quot;startPoint&quot;: &quot;#stickyBlockStartPoint&quot;,
                                &quot;endPoint&quot;: &quot;#stickyBlockEndPoint&quot;,
                                &quot;stickyOffsetTop&quot;: 40,
                                &quot;stickyOffsetBottom&quot;: 0
                              }" class="js-sticky-block">
                  <div id="spy_header" class="card-header py-3">
                    <div class="d-flex">
                      <div class="col">
                        <a href="#porteur" class="btn btn-info btn-block" data-parts="porteur_button">Porteur</a>
                        <div class="progress bg-soft-primary mt-1 h-20">
                          <div id="part1" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                               class="progress-bar" style="width: 0;"></div>
                        </div>
                      </div>

                      <div class="col">
                        <a href="#projet" class="btn btn-info btn-block" data-parts="projet_button">Projet</a>
                        <div class="progress bg-soft-primary mt-1 h-20">
                          <div id="part2" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                               class="progress-bar" style="width: 0;"></div>
                        </div>
                      </div>

                      <div class="col">
                        <a href="#déroulement" class="btn btn-info btn-block" data-parts="deroulement_button">Déroulement</a>
                        <div class="progress bg-soft-primary mt-1 h-20">
                          <div id="part3" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                               class="progress-bar" style="width: 0;"></div>
                        </div>
                      </div>

                      <div class="col">
                        <a href="#objectifs" class="btn btn-info btn-block" data-parts="obj_button">Objectifs</a>
                        <div class="progress bg-soft-primary mt-1 h-20">
                          <div id="part4" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                               class="progress-bar" style="width: 0;"></div>
                        </div>
                      </div>

                      <div class="col">
                        <a href="#budget" class="btn btn-info btn-block" data-parts="budget_button">Budget</a>
                        <div class="progress bg-soft-primary mt-1 h-20">
                          <div id="part5" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
                               class="progress-bar" style="width: 0;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="card-body" v-if="budget_filter > 0">

                <p class="text-right">
                  <i aria-hidden="true" class="fa fa-arrow-down fa-2x mr-2 text-primary"></i> : Cette icone montre une
                  réponse conditionnelle avec dépliant
                </p>

                <!--                  Identité du porteur de projet-->
                <div>

                  <h4 id="porteur" data-scroll="1" class="mb-4" style="scroll-margin-top: 140px;">
                    Identité du porteur de projet
                  </h4>

                  <!-- Nom du candidat -->
                  <div data-progress="part1" class="row form-group">
                    <label for="candidat_nom" class="col-sm-3 col-form-label input-label">
                      Nom du candidat
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_nom]" id="candidat_nom"
                             placeholder="Alain Dupont" aria-label="Alain Dupont" class="form-control"
                             v-model="candidat_nom">
                    </div>
                  </div>

                  <!-- Photo du candidat -->
                  <div class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">Photo du/des porteur(s)</label>
                    <div class="col-sm-9">

                      <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                              data-toggle="tooltip" data-placement="top"
                              title="Logo de la structure">
                        <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                             id="photo_porteur"
                             :src="photo_porteur"
                             alt="Votre avatar"/>
                        <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                          Ajouter / modifier la photo
                          <a href="javascript:;" class="stretched-link" data-toggle="modal"
                             data-target="#change_photo_porteur">
                            <i class="fa fa-question-circle"></i>
                          </a>
                        </figcaption>
                      </figure>

                      <dlnk-clipper
                          modal_id="change_photo_porteur"
                          @imgURL="set_photo_porteur($event)"
                          :crop_ratio="1">
                      </dlnk-clipper>

                    </div>
                  </div>

                  <!-- TODO : nouveau champ → description du porteur de projet -->
                  <!--
                  <div class="row form-group">
                      <label for="presPorteurLabel" class="col-sm-3 col-form-label input-label text-right">Décrivez rapidement votre porteur</label>

                      <div class="col-sm-9">
                          <textarea rows="3" class="form-control" name="presPorteur" id="presPorteurLabel" placeholder="Une description accrocheuse ..." aria-label="Une description accrocheuse ..."></textarea>
                      </div>
                  </div>
                  -->

                  <!-- Fonction du candidat -->
                  <div data-progress="part1" class="row form-group">
                    <label for="candidat_fonction"
                           class="col-sm-3 col-form-label input-label text-left">Fonction</label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_fonction]" id="candidat_fonction" placeholder="Manager"
                             aria-label="Manager" class="form-control" v-model="candidat_fonction">
                    </div>
                  </div>

                  <!-- Service du candidat -->
                  <div v-if="budget_filter>10000" data-progress="part1" class="row form-group">
                    <label for="candidat_service" class="col-sm-3 col-form-label input-label text-left">
                      Service (activité/rattachement)
                    </label>
                    <div class="col-sm-9">
                      <input type="text" name="aap[candidat_service]" id="candidat_service" v-model="candidat_service"
                             placeholder="Marketing" aria-label="Marketing" class="form-control">
                    </div>
                  </div>

                  <!-- Téléphone du candidat -->
                  <div data-progress="part1" class="row form-group">
                    <label for="candidat_telephone"
                           class="col-sm-3 col-form-label input-label text-left">Téléphone</label>
                    <div class="col-sm-9">
                      <input type="tel" name="aap[candidat_telephone]" id="candidat_telephone"
                             placeholder="01 23 45 67 89"
                             aria-label="01 23 45 67 89" class="form-control" v-model="candidat_telephone">
                    </div>
                  </div>

                  <!-- Email du candidat -->
                  <div data-progress="part1" class="row form-group">
                    <label for="candidat_email" class="col-sm-3 col-form-label input-label text-right">Email</label>
                    <div class="col-sm-9">
                      <input type="email" name="aap[candidat_email]" id="candidat_email" placeholder="porteur@mail.fr"
                             aria-label="porteur@mail.fr" class="form-control" v-model="candidat_email">
                    </div>
                  </div>

                  <div v-if="budget_filter>1000" data-progress="part1" class="row form-group">
                    <label class="col-sm-3 col-form-label input-label">
                      Avez-vous mené des projets au cours des 2 années précédentes ?
                      <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                    </label>

                    <!-- Projets récents -->
                    <div class="col-sm-9 my-auto">
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[actions_recentes]" id="actions_recentes_oui"
                               @change="toggleCollapse('#actions_recentes')" class="form-check-input"
                               :checked="actions_recentes === true">
                        <label for="actions_recentes_oui" class="form-check-label">
                          Oui
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input type="radio" name="aap[actions_recentes]" id="actions_recentes_non"
                               @change="toggleCollapse('#actions_recentes',false)" class="form-check-input"
                               :checked="actions_recentes != true">
                        <label for="actions_recentes_non" class="form-check-label">
                          Non
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- projets menés ces 2 dernières annèes -->
                  <div v-if="budget_filter>1000" id="actions_recentes" class="collapse"
                       v-bind:class="{show : actions_recentes}">
                    <div class="row form-group">
                      <label for="actions_recentes_description"
                             class="col-sm-3 col-form-label input-label text-right">
                        Vos projets mené ces 2 dernières annèes
                      </label>
                      <div class="col-sm-9">
                          <textarea rows="3"
                                    name="aap[actions_recentes_description]"
                                    id="actions_recentes_description"
                                    v-model="actions_recentes_description"
                                    placeholder="Inclusion numérique 2021" aria-label="Inclusion numérique 2021"
                                    class="form-control"></textarea>
                      </div>
                    </div>

                    <!-- financeurs ces 2 dernières annèes -->
                    <div class="row form-group">
                      <label for="financeur_recent" class="col-sm-3 col-form-label input-label text-right">
                        Vos financeurs ces 2 dernières années
                      </label>
                      <div class="col-sm-9">
                          <textarea rows="3" name="aap[financeur_recent]"
                                    id="financeur_recent" placeholder="Financeur pour inclusion numérique"
                                    v-model="financeur_recent"
                                    aria-label="Financeur pour inclusion numérique" class="form-control"></textarea>
                      </div>
                    </div>

                    <!-- Ces projets ont-ils été co-portés -->
                    <div class="row form-group">
                      <label class="col-sm-3 col-form-label input-label">
                        Ces projets ont-ils été co-portés ?
                        <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                      </label>
                      <div class="col-sm-9 my-auto">
                        <div class="form-check form-check-inline">
                          <input type="radio" name="aap[coporte_recent]"
                                 id="coporte_recent_oui"
                                 @change="toggleCollapse('#tiroir_coporte');evalProg('part1')"
                                 class="form-check-input" :checked="coporte_recent === true">
                          <label for="coporte_recent_oui"
                                 class="form-check-label">Oui</label>
                        </div>

                        <div class="form-check form-check-inline">
                          <input type="radio" name="aap[coporte_recent]"
                                 id="coporte_recent_non" @change="toggleCollapse('#tiroir_coporte',false)"
                                 class="form-check-input" :checked="coporte_recent != true">
                          <label for="coporte_recent_non" class="form-check-label">Non</label>
                        </div>
                      </div>
                    </div>

                    <!-- Expertise co-porte -->
                    <div id="tiroir_coporte" class="collapse" v-bind:class="{show : coporte_recent}">
                      <div class="row form-group">
                        <label for="coporte_recent_description"
                               class="col-sm-3 col-form-label input-label text-right">
                          Quelles expertises complémentaires ont été combinées pour la(les) mener?
                        </label>
                        <div class="col-sm-9">
                            <textarea rows="3" name="aap[coporte_recent_description]" id="coporte_recent_description"
                                      placeholder="Expertise ..." class="form-control"
                                      v-model="coporte_recent_description"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <hr data-scroll="2" class="my-6 mw-66 mx-auto">
                <h4 id="projet" class="mb-4" style="scroll-margin-top: 140px;">Identité du projet</h4>

                <!-- Nom du projet -->
                <div data-progress="part1" class="row form-group">
                  <label for="projet_nom" class="col-sm-3 col-form-label input-label text-left">Nom du projet</label>
                  <div class="col-sm-9">
                    <input type="email" name="aap[projet_nom]" id="projet_nom" placeholder="Le nom du projet"
                           aria-label="porteur@mail.fr" class="form-control" v-model="projet_nom">
                  </div>
                </div>

                <div data-progress="part2" class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">Thématiques</label>
                  <div class="col-sm-9 py-3">
                    <input type="hidden" name="aap[aap_tag_ids][]" value="">
                    <div class="form-check" v-for="tag in aap_tags" :key="tag.id">
                      <input type="checkbox" value="" :id="'aap_tag_' + tag.id" name="aap[aap_tag_ids][]"
                             class="form-check-input" :value="tag.id"
                             :checked="Object.values(aap_tag_ids).includes(tag.id) ">
                      <label :for="'aap_tag_' + tag.id" class="form-check-label font-size-1">
                        {{ tag.nom }}
                      </label>
                    </div>
                  </div>
                </div>

                <h6 class="mb-4 ml-3">Précisez les dates du projet</h6>

                <div class="row form-group ml-3">
                  <!-- Date de début-->
                  <div data-progress="part2" class="col-6">
                    <label for="date_debut" class="input-label">
                      Date de début
                    </label>
                    <div class="col-sm-9 mw-100 px-0">
                      <input type="date" name="aap[date_debut]" id="date_debut" placeholder="2021-07-01"
                             aria-label="2021-07-01" class="form-control" v-model="date_debut">
                    </div>
                  </div>
                  <!-- Date de fin-->
                  <div data-progress="part2" class="col-6">
                    <label for="date_fin" class="input-label">
                      Date de fin
                    </label>
                    <div class="col-sm-9 mw-100 px-0">
                      <input type="date" name="aap[date_fin]" id="date_fin" placeholder="2021-08-31"
                             aria-label="2021-08-31" class="form-control" v-model="date_fin">
                    </div>
                  </div>
                </div>

                <h6 class="mt-4 mb-4 ml-3">Brièvement, quelles sont les principales étapes du projet ?</h6>
                <div class="col-12">

                  <div class="mt-2"
                       v-for="etape in aap.etapes" :key="etape.id" :id="'etapes_' + etape.id">
                    <hr>
                    <input type="hidden" :value="etape.id"
                           :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][id]'"
                           :id="'etape_id_' + etape.id">

                    <div data-progress="part2" class="row form-group ml-3">
                      <label :for="'etape_etape_' + etape.id"
                             class="col-sm-3 col-form-label input-label">Étape</label>
                      <div class="col-sm-9">
                        <input type="text" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][etape]'"
                               :id="'etape_etape_' + etape.id"
                               placeholder="Etape n°1" aria-label="Etape n°1" class="form-control" data-name="etape"
                               :value="etape.etape">
                      </div>
                    </div>
                    <div data-progress="part2" class="row form-group ml-3">
                      <label :for="'etape_date_' + etape.id" class="col-sm-3 col-form-label input-label">Date</label>
                      <div class="col-sm-9">
                        <div class="input-group">
                          <input type="date" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][date]'"
                                 :id="'etape_date_' + etape.id"
                                 class="form-control"
                                 data-name="date" :value="etape.date">
                        </div>
                      </div>
                    </div>
                    <div data-progress="part2" class="row form-group ml-3 mb-0">
                      <label :for="'etape_description_' + etape.id" class="col-sm-3 col-form-label input-label">Description</label>
                      <div class="col-sm-9">
                          <textarea rows="3" :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][description]'"
                                    :value="etape.description"
                                    :id="'etape_description_' + etape.id" placeholder="Description n°1"
                                    aria-label="Description n°1"
                                    class="form-control" data-name="description"></textarea>
                      </div>
                    </div>

                    <input value="false"
                           type="hidden"
                           :name="'aap[aap_etapes_projets_attributes][' + etape.id + '][_destroy]'"
                           :id="'aap_etapes_projets_attributes_' + etape.id">

                    <button type="button" class="btn btn-danger" :disabled="aap.status_id == 9"
                            @click="delete_element('aap_etapes_projets_attributes_' + etape.id, 'etapes_' + etape.id)">
                      <i class="fas fa-times">&nbsp; Supprimer</i>
                    </button>

                  </div>

                  <div id="etape_01" class="mt-2" data-attribute="aap[aap_etapes_projets_attributes]">
                    <hr>

                    <div class="card">
                      <div class="card-header bg-primary text-white p-2">
                        Nouvelle étape
                      </div>
                      <div class="card-body">
                        <div data-progress="part2" class="row form-group ml-3">
                          <label for="etape_etape_01" class="col-sm-3 col-form-label input-label">Étape</label>
                          <div class="col-sm-9">
                            <input type="text" name="aap[aap_etapes_projets_attributes][0][etape]" id="etape_etape_01"
                                   placeholder="Etape" aria-label="Etape" class="form-control" data-name="etape"
                                   v-model="new_etape_etape">
                          </div>
                        </div>
                        <div data-progress="part2" class="row form-group ml-3">
                          <label for="etape_date_01" class="col-sm-3 col-form-label input-label">Date</label>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input type="date" name="aap[aap_etapes_projets_attributes][0][date]" id="etape_date_01"
                                     class="form-control" data-name="date" v-model="new_etape_date">
                            </div>
                          </div>
                        </div>
                        <div data-progress="part2" class="row form-group ml-3 mb-0">
                          <label for="etape_description_01"
                                 class="col-sm-3 col-form-label input-label">Description</label>
                          <div class="col-sm-9">
                          <textarea rows="3" name="aap[aap_etapes_projets_attributes][0][description]"
                                    id="etape_description_01" placeholder="Description n°1" aria-label="Description n°1"
                                    class="form-control" data-name="description"
                                    v-model="new_etape_description"></textarea>
                          </div>
                        </div>

                        <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                          <i class="fas fa-plus"></i>
                        </a>

                      </div>

                    </div>

                  </div>
                </div>

                <h6 v-if="budget_filter>1000" class="my-4">Origine du projet</h6>

                <!-- origine -->
                <div v-if="budget_filter>1000" data-progress="part2" class="row form-group ml-3">
                  <label for="origine" class="col-sm-3 col-form-label input-label">
                    Pourquoi ce projet est-il né ?
                  </label>
                  <div class="col-sm-9">
                      <textarea rows="3" name="aap[origine]" id="origine"
                                placeholder="Une description accrocheuse ..."
                                aria-label="Une description accrocheuse ..." class="form-control"
                                v-model="origine"></textarea>
                  </div>
                </div>

                <!-- TODO : Illustration des ORIGINES du projet -->

                <!--
                <div v-if="budget_filter>1000" class="row form-group">
                    <label class="col-sm-3 col-form-label input-label ml-3">Illustrez les origines du projet</label>
                    <div class="col-sm-9">

                      <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                              data-toggle="tooltip" data-placement="top"
                              title="Image origines">
                        <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                            id="photo_origine"
                            :src="TODO"
                            alt="Votre avatar"/>
                        <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                          Ajouter / modifier la photo
                          <a href="javascript:;" class="stretched-link" data-toggle="modal"
                            data-target="#change_photo_origines">
                            <i class="fa fa-question-circle"></i>
                          </a>
                        </figcaption>
                      </figure>

                      <dlnk-clipper
                          modal_id="change_photo_origines"
                          @imgURL="TODO"
                          :crop_ratio="1">
                      </dlnk-clipper>

                    </div>
                </div>
                -->

                <h6 class="my-4">Présentation du projet</h6>

                <!--  Présentation du projet -->
                <div data-progress="part2" class="row form-group ml-3">
                  <label for="presentation" class="col-sm-3 col-form-label input-label">
                    Comment présenteriez-vous votre projet?
                  </label>
                  <div class="col-sm-9">
                      <textarea rows="3" name="aap[presentation]" id="presentation"
                                placeholder="Une description accrocheuse ..."
                                aria-label="Une description accrocheuse ..." class="form-control"
                                v-model="presentation"></textarea>
                  </div>
                </div>


                <!-- Illustrez votre projet -->
                <div class="row form-group ml-3">
                  <label class="col-sm-3 col-form-label input-label ml-3">
                    Illustrez votre projet
                  </label>

                  <div class="col-sm-9">

                    <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                            data-toggle="tooltip" data-placement="top"
                            title="Logo de la structure">
                      <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                           id="projet_illustration"
                           :src="projet_illustration"
                           alt="Votre avatar"/>
                      <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                        Ajouter / modifier la photo
                        <a href="javascript:;" class="stretched-link" data-toggle="modal"
                           data-target="#change_projet_illustration">
                          <i class="fa fa-question-circle"></i>
                        </a>
                      </figcaption>
                    </figure>

                    <dlnk-clipper
                        modal_id="change_projet_illustration"
                        @imgURL="set_projet_illustration($event)"
                        :crop_ratio="1">
                    </dlnk-clipper>


                  </div>
                </div>


                <hr data-scroll="3" class="my-6 mw-66 mx-auto">


                <h4 v-if="budget_filter>5000" id="déroulement" class="my-4" style="scroll-margin-top: 140px;">
                  Déroulement du projet</h4>

                <h6 v-if="budget_filter>10000" class="my-4">Temporalité et participants</h6>


                <!-- Combien d'évènements ponctuels vont avoir lieu ?-->
                <div v-if="budget_filter>10000" data-progress="part3" class="row form-group ml-3">
                  <label for="evenements_ponctuel" class="col-sm-3 col-form-label input-label">
                    Combien d'évènements ponctuels vont avoir lieu ?
                  </label>
                  <div class="col-sm-9">
                    <input type="number" name="aap[evenements_ponctuel]" id="evenements_ponctuel"
                           placeholder="5" min="0" step="1"
                           aria-label="5" class="form-control" v-model="evenements_ponctuel">
                  </div>
                </div>

                <!-- Combien d'activités à l'année vont avoir lieu ?  -->
                <div v-if="budget_filter>10000" data-progress="part3" class="row form-group ml-3">
                  <label for="activites_annuelles" class="col-sm-3 col-form-label input-label">
                    Combien d'activités à l'année vont avoir lieu ?
                  </label>
                  <div class="col-sm-9">
                    <input type="number" name="aap[activites_annuelles]" id="activites_annuelles" min="0" step="1"
                           placeholder="5" aria-label="5" class="form-control" v-model="activites_annuelles">
                  </div>
                </div>

                <!-- Combien d'ateliers par activité programmez-vous ? -->
                <div v-if="budget_filter>10000" data-progress="part3" class="row form-group ml-3">
                  <label for="ateliers_activite" class="col-sm-3 col-form-label input-label">
                    Combien d'ateliers par activité programmez-vous ?
                  </label>
                  <div class="col-sm-9">
                    <input type="number" name="aap[ateliers_activite]" id="ateliers_activite" placeholder="5"
                           min="0" step="1" aria-label="5" class="form-control" v-model="ateliers_activite">
                  </div>
                </div>


                <h6 v-if="budget_filter>5000" class="mt-4 mb-4 ml-3">Détail du programme</h6>

                <div v-if="budget_filter>5000">
                  <div :id="'etapes_' + activite.id" class="col-12" v-for="activite in aap.activites"
                       :key="activite.id">
                    <input type="hidden" :value="activite.id"
                           :name="'aap[aap_activites_projets_attributes][' + activite.id + '][id]'"
                           :id="'activite_id_' + activite.id">
                    <div data-progress="part3" class="row form-group ml-3">
                      <label :for="'activite_' + activite.id"
                             class="col-sm-3 col-form-label input-label">Activité</label>
                      <div class="col-sm-9">
                        <input type="text"
                               :name="'aap[aap_activites_projets_attributes][' + activite.id + '][activite]'"
                               :id="'activite_' + activite.id" aria-label="Prestation" class="form-control"
                               :value="activite.activite">
                      </div>
                    </div>

                    <div data-progress="part3" class="row form-group ml-3 mb-0">
                      <label :for="'aap_activites_description_' + activite.id"
                             class="col-sm-3 col-form-label input-label">Description</label>
                      <div class="col-sm-9">
                        <textarea rows="3"
                                  :name="'aap[aap_activites_projets_attributes][' + activite.id + '][description]'"
                                  :id="'aap_activites_description_' + activite.id" placeholder="Description"
                                  :value="activite.description"
                                  aria-label="Description n°1" class="form-control"></textarea>
                      </div>
                    </div>

                    <input value="false"
                           type="hidden"
                           :name="'aap[aap_activites_projets_attributes][' + activite.id + '][_destroy]'"
                           :id="'aap_activites_projets_attributes' + activite.id">

                    <button type="button" class="btn btn-danger" :disabled="aap.status_id == 9"
                            @click="delete_element('aap_activites_projets_attributes' + activite.id, 'etapes_' + activite.id)">
                      <i class="fas fa-times">&nbsp; Supprimer</i>
                    </button>

                  </div>

                  <div class="card">
                    <div class="card-header bg-primary p-2 text-white">
                      Ajouter une activité
                    </div>

                    <div class="card-body">
                      <div id="activite_1" class="col-12">
                        <div data-progress="part3" class="row form-group ml-3">
                          <label for="prestationLabel" class="col-sm-3 col-form-label input-label">Activité</label>
                          <div class="col-sm-9">
                            <input type="text"
                                   name="aap[aap_activites_projets_attributes][0][activite]"
                                   id="prestationLabel" placeholder="Activité n°1" aria-label="Prestation n°1"
                                   class="form-control"
                                   v-model="new_activite_activite">
                          </div>
                        </div>

                        <div data-progress="part3" class="row form-group ml-3 mb-0">
                          <label for="aap_activites_projets_attributes" class="col-sm-3 col-form-label input-label">Description</label>
                          <div class="col-sm-9">
                                  <textarea rows="3"
                                            name="aap[aap_activites_projets_attributes][0][description]"
                                            id="aap_activites_projets_attributes" placeholder="Description n°1"
                                            v-model="new_activite_description"
                                            aria-label="Description n°1" class="form-control"></textarea>
                          </div>
                        </div>

                        <!-- TODO : illustration d'une ACTIVITE -->
                        <!--
                        <div class="row form-group ml-3">
                          <label class="col-sm-3 col-form-label input-label ml-3">Illustrez votre activité</label>
                          <div class="col-sm-9">
                            <div class="media align-items-center">

                              <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                      data-toggle="tooltip" data-placement="top"
                                      title="Image de l'activité">
                                <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                                    id="image_activite_1"
                                    :src="TODO"
                                    alt="Votre avatar"/>
                                <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                                  Ajouter / modifier la photo
                                  <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                                    data-target="#change_image_activite">
                                    <i class="fa fa-question-circle"></i>
                                  </a>
                                </figcaption>
                              </figure>

                              <dlnk-clipper
                                  modal_id="change_image_activite"
                                  @imgURL="TODO"
                                  :crop_ratio="1">
                              </dlnk-clipper>


                            </div>
                          </div>
                        </div>
                        -->


                      </div>
                      <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                        <i class="fas fa-plus"></i>
                      </a>
                    </div>
                  </div>
                </div>


                <h6 v-if="budget_filter>10000" class="my-4">Quels intervenants extérieurs seront présents ?
                </h6>

                <div v-if="budget_filter>10000">
                  <div class="row form-group ml-3 mb-0" v-for="intervenant in aap.intervenants"
                       :id="'intervenant_' + intervenant.id">
                    <input type="hidden" :value="intervenant.id"
                           :name="'aap[aap_intervenants_projets_attributes][' + intervenant.id + '][id]'"
                           :id="'intervenant_id_' + intervenant.id">
                    <div class="col-6">
                      <label :for="'intervenant_fonction' + intervenant.id" class="input-label">Type
                        d'intervenant</label>
                      <div class="col-sm-9 mw-100 px-0">
                        <input type="text" :value="intervenant.fonction"
                               :name="'aap[aap_intervenants_projets_attributes][' + intervenant.id + '][fonction]'"
                               :id="'intervenant_fonction' + intervenant.id" class="form-control">
                      </div>
                    </div>
                    <div class="col-6">
                      <label :for="'intervenant_nombre' + intervenant.id" class="input-label">Nombre</label>
                      <div class="col-sm-9 mw-100 px-0">
                        <input type="number" :id="'intervenant_nombre' + intervenant.id" :value="intervenant.nombre"
                               :name="'aap[aap_intervenants_projets_attributes][' + intervenant.id + '][nombre]'"
                               class="form-control" min="0" step="1">
                      </div>
                    </div>

                    <input value="false"
                           type="hidden"
                           :name="'aap[aap_intervenants_projets_attributes][' + intervenant.id + '][_destroy]'"
                           :id="'aap_intervenants_projets_attributes' + intervenant.id">

                    <button type="button" class="btn btn-danger mb-2"
                            @click="delete_element('aap_intervenants_projets_attributes' + intervenant.id, 'intervenant_' + intervenant.id)">
                      <i class="fas fa-times">&nbsp; Supprimer</i>
                    </button>

                  </div>

                  <div class="card mt-3">
                    <div class="card-header bg-primary text-white p-2">
                      Ajouter un intervenant
                    </div>
                    <div class="card-body">
                      <div class="row form-group ml-3 mb-0" id="intervenant_1">
                        <div class="col-6">
                          <label for="aap_intervenants_projets_attributes_fonction" class="input-label">Type
                            d'intervenant</label>
                          <div class="col-sm-9 mw-100 px-0">
                            <input type="text"
                                   name="aap[aap_intervenants_projets_attributes][0][fonction]"
                                   id="aap_intervenants_projets_attributes_fonction" placeholder="Coach Sportif"
                                   aria-label="Coach Sportif" class="form-control" v-model="new_intervenant_fonction">
                          </div>
                        </div>
                        <div class="col-6">
                          <label for="aap_intervenants_projets_attributes_nombre" class="input-label">Nombre</label>
                          <div class="col-sm-9 mw-100 px-0">
                            <input type="number" id="aap_intervenants_projets_attributes_nombre"
                                   min="0" step="1"
                                   name="aap[aap_intervenants_projets_attributes][0][nombre]"
                                   placeholder="2" aria-label="2" class="form-control"
                                   v-model="new_intervenant_nombre">
                          </div>
                        </div>
                      </div>

                      <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                        <i class="fas fa-plus"></i>
                      </a>
                    </div>
                  </div>

                </div>


                <h6 v-if="budget_filter>5000" class="my-4">Quels sont les moyens humains engagés sur le projet ?</h6>
                <div v-if="budget_filter>5000" class="col-12">

                  <div class="row mx-n2">

                    <!-- CDI -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">CDI</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_cdi" class="input-label"> Nombre de personnes </label>
                      <input min="0" type="number" placeholder="10" aria-label="10" class="form-control"
                             id="nombre_cdi"
                             name="aap[nombre_cdi]" v-model="nombre_cdi">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_cdi_etp" class="input-label">Nombre d'ETP </label>
                      <input min="0" type="number" name="aap[nombre_cdi_etp]" id="nombre_cdi_etp" placeholder="1.2"
                             aria-label="1.2" step="0.1"
                             class="form-control" v-model="nombre_cdi_etp">
                    </div>


                    <!-- CDD -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">CDD</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_cdd" class="input-label"> Nombre de personnes </label>
                      <input min="0" type="number" placeholder="10" aria-label="10" class="form-control"
                             name="aap[nombre_cdd]"
                             id="nombre_cdd" v-model="nombre_cdd">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_cdd_etp" class="input-label">Nombre d'ETP </label>
                      <input min="0" type="number" name="aap[nombre_cdd_etp]" id="nombre_cdd_etp" step="0.1"
                             placeholder="1.2" aria-label="1.2" v-model="nombre_cdd_etp" class="form-control">
                    </div>

                  </div>

                  <div v-if="budget_filter>10000" class="row mx-n2">

                    <!-- Précaire -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">Statuts précaires
                        <span class="font-size-1 text-muted">(intérimaires, vacataires, intermittents)</span>
                      </h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_precaire" class="input-label"> Nombre de personnes</label>
                      <input min="0" type="number" placeholder="10" aria-label="10" class="form-control"
                             name="aap[nombre_precaire]"
                             id="nombre_precaire" v-model="nombre_precaire">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_precaire_etp" class="input-label">Nombre d'ETP</label>
                      <input min="0" type="number" name="aap[nombre_precaire_etp]" id="nombre_precaire_etp"
                             placeholder="1.2" step="0.1"
                             aria-label="1.2" class="form-control" v-model="nombre_precaire_etp">
                    </div>

                    <!-- Contrat aidés  -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">Contrats aidés</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_contrat_aides" class="input-label"> Nombre de personnes</label>
                      <input name="aap[nombre_contrat_aides]" id="nombre_contrat_aides" min="0" type="number"
                             placeholder="10"
                             aria-label="10" class="form-control" v-model="nombre_contrat_aides">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_contrat_aides_etp" class="input-label">Nombre d'ETP</label>
                      <input min="0" type="number" name="aap[nombre_contrat_aides_etp]" id="nombre_contrat_aides_etp"
                             placeholder="1.2" step="0.1"
                             aria-label="1.2" class="form-control" v-model="nombre_contrat_aides_etp">
                    </div>

                  </div>

                  <div v-if="budget_filter>10000" class="row mx-n2">

                    <!-- Bénévoles -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">Bénévoles</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_benevoles" class="input-label"> Nombre de personnes </label>
                      <input min="0" type="number" name="aap[nombre_benevoles]" id="nombre_benevoles"
                             v-model="nombre_benevoles"
                             placeholder="10" aria-label="10" class="form-control">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_benevoles_etp" class="input-label">Nombre d'ETP </label>
                      <input min="0" type="number" name="aap[nombre_benevoles_etp]" id="nombre_benevoles_etp"
                             placeholder="1.2" step="0.1"
                             aria-label="1.2" class="form-control" v-model="nombre_benevoles_etp">
                    </div>

                    <!-- Fonctionnaire -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">Fonctionnaires</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_fonctionnaires" class="input-label"> Nombre de personnes </label>
                      <input min="0" type="number" id="nombre_fonctionnaires" name="aap[nombre_fonctionnaires]"
                             v-model="nombre_fonctionnaires"
                             placeholder="10" aria-label="10" class="form-control">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_fonctionnaires_etp" class="input-label">Nombre d'ETP </label>
                      <input min="0" type="number" name="aap[nombre_fonctionnaires_etp]"
                             id="nombre_fonctionnaires_etp"
                             placeholder="1.2" step="0.1"
                             aria-label="1.2" class="form-control" v-model="nombre_fonctionnaires_etp">
                    </div>
                  </div>

                  <div v-if="budget_filter>10000" class="row mx-n2">
                    <!-- Autres -->
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <h5 class="vertical-align-center text-right pr-4">Autres</h5>
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_autres" class="input-label"> Nombre de personnes </label>
                      <input min="0" type="number" id="nombre_autres" name="aap[nombre_autres]"
                             v-model="nombre_autres"
                             placeholder="10" aria-label="10" class="form-control">
                    </div>
                    <div class="col-sm-8 col-lg-2 px-2 mb-2">
                      <label for="nombre_autres_etp" class="input-label">Nombre d'ETP </label>
                      <input min="0" type="number" name="aap[nombre_autres_etp]" id="nombre_autres_etp"
                             placeholder="1.2" step="0.1"
                             aria-label="1.2"
                             class="form-control" v-model="nombre_autres_etp">
                    </div>
                  </div>


                  <div class="d-flex justify-content-center">
                    <div data-progress="part3" class="row form-group ml-3"><label
                        class="col-form-label input-label mr-3">Nombre de personnes total</label>
                      <div><input readonly="readonly" min="0" type="number" id="total_personnes" placeholder="0"
                                  class="form-control" v-model="total_personne"></div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <div data-progress="part3" class="row form-group ml-3"><label
                        class="col-form-label input-label mr-3">Nombre ETP total</label>
                      <div><input readonly="readonly" min="0" type="number" id="total_etp" placeholder="0"
                                  class="form-control" v-model="total_etp"></div>
                    </div>
                  </div>
                  <!--                    <p class="mw-100 ml-6 font-size-1 text-center text-info">-->
                  <!--                      <br>ETP (nombre d'heures effectuées/1607)-->
                  <!--                    </p>-->
                </div>

                <hr data-scroll="4" class="my-6 mw-66 mx-auto">

                <h4 id="objectifs" class="my-4" style="scroll-margin-top: 140px;">Objectifs du projet</h4>

                <h6 class="mt-4 mb-4 ml-3">Quel est l'objectif global ?</h6>

                <!--  projet_objectif -->
                <div>
                  <div data-progress="part4" class="row form-group ml-3">
                    <label for="projet_objectif" class="col-sm-3 col-form-label input-label">Objectif</label>
                    <div class="col-sm-9">
                        <textarea rows="3" v-model="projet_objectif" name="aap[projet_objectif]" id="projet_objectif"
                                  placeholder="Objectif global" aria-label="Objectif global"
                                  class="form-control"></textarea>
                    </div>
                  </div>
                </div>

                <h6 class="mt-4 mb-4 ml-3">Quels sont les objectifs opérationnels ?</h6>

                <div>
                  <div :id="'obj_ope_' + objectif.id" v-for="objectif in aap.objectifs" :key="objectif.id">
                    <input type="hidden" :value="objectif.id"
                           :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][id]'"
                           :id="'objectif' + objectif.id">

                    <div data-progress="part4" class="row form-group ml-3">
                      <label :for="'objectifs_objectif' + objectif.id" class="col-sm-3 col-form-label input-label">
                        Objectif opérationnel
                      </label>
                      <div class="col-sm-9">
                        <input type="text" :value="objectif.objectif"
                               :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][objectif]'"
                               :id="'objectifs_objectif' + objectif.id"
                               placeholder="Objectif opérationnel" aria-label="Objectif opérationnel"
                               class="form-control">
                      </div>
                    </div>
                    <div data-progress="part4" class="row form-group ml-3">
                      <label :for="'objectifs_description' + objectif.id" class="col-sm-3 col-form-label input-label">Description</label>
                      <div class="col-sm-9">
                        <textarea rows="3" :value="objectif.description"
                                  :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][description]'"
                                  id="'objectifs_description' + objectif.id" placeholder="Description"
                                  aria-label="Description"
                                  class="form-control"></textarea>
                      </div>
                    </div>

                    <div v-if="budget_filter>5000" data-progress="part4" class="row form-group ml-3">
                      <label :for="'objectifs_risque' + objectif.id"
                             class="col-sm-3 col-form-label input-label">
                        Quel est le risque que cet objectif ne soit pas atteint ?
                      </label>
                      <div class="col-sm-9">
                          <textarea rows="3"
                                    :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][risque]'"
                                    id="'objectifs_risque' + objectif.id" placeholder="Risque"
                                    :value="objectif.risque"
                                    aria-label="Risque" class="form-control"></textarea>
                      </div>
                    </div>

                    <input value="false"
                           type="hidden"
                           :name="'aap[aap_objectifs_projets_attributes][' + objectif.id + '][_destroy]'"
                           :id="'aap_objectifs_projets_attributes' + objectif.id">

                    <button type="button" class="btn btn-danger my-2"
                            @click="delete_element('aap_objectifs_projets_attributes' + objectif.id, 'obj_ope_' + objectif.id)">
                      <i class="fas fa-times">&nbsp; Supprimer</i>
                    </button>

                  </div>


                  <div class="card">
                    <div class="card-header bg-primary text-white p-2">
                      Ajouter un objectif opérationnel
                    </div>
                    <div class="card-body">
                      <div id="objectif_operationnel">
                        <div data-progress="part4" class="row form-group ml-3">
                          <label for="objectifs_operationnel_objectif"
                                 class="col-sm-3 col-form-label input-label">Objectif opérationnel</label>
                          <div class="col-sm-9">
                            <input type="text"
                                   name="aap[aap_objectifs_projets_attributes][0][objectif]"
                                   id="objectifs_operationnel_objectif" v-model="new_objectif_objectif"
                                   placeholder="Objectif opérationnel" aria-label="Objectif opérationnel"
                                   class="form-control">
                          </div>
                        </div>
                        <div data-progress="part4" class="row form-group ml-3">
                          <label for="objectifs_operationnel_description"
                                 class="col-sm-3 col-form-label input-label">Description</label>
                          <div class="col-sm-9">
                              <textarea rows="3"
                                        name="aap[aap_objectifs_projets_attributes][0][description]"
                                        id="objectifs_operationnel_description" placeholder="Description"
                                        aria-label="Description" class="form-control"
                                        v-model="new_objectif_description"></textarea>
                          </div>
                        </div>
                        <div v-if="budget_filter>5000" data-progress="part4" class="row form-group ml-3">
                          <label for="aap_objectifs_projets_attributes_risque"
                                 class="col-sm-3 col-form-label input-label">
                            Quel est le risque que cet objectif ne soit pas atteint ?
                          </label>
                          <div class="col-sm-9">
                              <textarea rows="3"
                                        name="aap[aap_objectifs_projets_attributes][0][risque]"
                                        id="aap_objectifs_projets_attributes_risque" placeholder="Risque n°1"
                                        data-name="risque" v-model="new_objectif_risque"
                                        aria-label="Risque n°1" class="form-control"></textarea>
                          </div>
                        </div>

                        <!-- TODO : illustration d'un OBJECTIF -->
                        <!--
                        <div class="row form-group"><label class="col-sm-3 col-form-label input-label ml-3">Illustrez votre objectif</label>
                          <div class="col-sm-9">
                            <div class="media align-items-center">

                              <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                                      data-toggle="tooltip" data-placement="top"
                                      title="Image de l'objectif">
                                <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                                    id="image_objectif_1"
                                    :src="TODO"
                                    alt="Votre avatar"/>
                                <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                                  Ajouter / modifier la photo
                                  <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                                    data-target="#change_image_objectif">
                                    <i class="fa fa-question-circle"></i>
                                  </a>
                                </figcaption>
                              </figure>

                              <dlnk-clipper
                                  modal_id="change_image_objectif"
                                  @imgURL="TODO"
                                  :crop_ratio="1">
                              </dlnk-clipper>


                            </div>
                          </div>
                        </div>
                        -->


                      </div>

                      <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                        <i class="fas fa-plus"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <h6 class="my-4">Où va se dérouler le projet ?</h6>
                <div class="px-2">
                  <label class="input-label-secondary ml-0">
                    Sélectionner les communes de TAD concernées
                  </label>

                  <div data-progress="part4" class="row">
                    <!--                      <div class="custom-control custom-checkbox col-12">-->
                    <!--                        <input type="checkbox" id="commune_all"-->
                    <!--                               class="custom-control-input" name="commune_all" @click="checkAllCities($event)">-->
                    <!--                        <label for="commune_all" class="custom-control-label font-weight-bold">-->
                    <!--                          Toutes-->
                    <!--                        </label>-->
                    <!--                      </div>-->

                    <input type="hidden" name="aap[aap_tag_ids][]" value="">
                    <div class="w-100 d-flex" style="flex-wrap: wrap" id="commune_checkboxes">
                      <div class="custom-control custom-checkbox col-4" v-for="commune in aap_communes"
                           :key="commune.id">

                        <input type="checkbox" :id="'commune_' + commune.id" :value="commune.id"
                               class="custom-control-input" name="aap[aap_commune_ids][]"
                               :checked="Object.values(aap_commune_ids).includes(commune.id)">
                        <label :for="'commune_' + commune.id" class="custom-control-label">
                          {{ commune.nom }}
                        </label>
                      </div>
                    </div>
                  </div>


                </div>

                <h6 class="mt-4">Si quartier prioritaire concerné : </h6>

                <div data-progress="part4" class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">Quartier(s) :</label>
                  <div class="col-sm-9 py-3">
                    <input type="hidden" name="aap[aap_quartier_ids][]" value="">
                    <div class="custom-control custom-checkbox col-4" v-for="quartier in aap_quartiers"
                         :key="quartier.id">
                      <input type="checkbox" value="" :id="'aap_quartier_' + quartier.id"
                             name="aap[aap_quartier_ids][]"
                             class="custom-control-input" :value="quartier.id"
                             :checked="Object.values(aap_quartier_ids).includes(quartier.id) ">
                      <label :for="'aap_quartier_' + quartier.id" class="custom-control-label">
                        {{ quartier.nom }}
                      </label>
                    </div>
                  </div>
                </div>


                <!--                  <div class="row form-group">-->
                <!--                    <label class="col-sm-3 col-form-label input-label">Quartier</label>-->
                <!--                    <div class="col-sm-9 py-3">-->
                <!--                      <input type="hidden" name="aap[aap_quartier_ids][]" value="">-->
                <!--                      <div class="form-check" :v-for="quartier in aap_quartiers" :key="quartier.id">-->
                <!--                        <input type="checkbox" :value="quartier.id" :id="'aap_quartier_' + quartier.id"-->
                <!--                               name="aap[aap_quartier_ids][]" class="form-check-input"-->
                <!--                               :checked="Object.values(aap_quartier_ids).includes(quartier.id) ">-->
                <!--                        <label :for="'aap_quartier_' + quartier.id" class="form-check-label font-size-1">-->
                <!--                          {{ quartier.nom }}-->
                <!--                        </label>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                  </div>-->


                <!--                  &lt;!&ndash; Form Group &ndash;&gt;-->
                <!--                  <div class="col-12 ml-3">-->

                <!--                    <div class="form-check collapse" id="quartier1">-->
                <!--                      <input class="form-check-input" type="checkbox" value="" id="qpv1">-->
                <!--                      <label class="form-check-label font-size-1" for="qpv1">-->
                <!--                        Les Alouettes (Carrières sur seine)-->
                <!--                      </label>-->
                <!--                    </div>-->

                <!--                    <div class="form-check collapse" id="quartier2">-->
                <!--                      <input class="form-check-input" type="checkbox" value="" id="qpv2">-->
                <!--                      <label class="form-check-label font-size-1" for="qpv2">-->
                <!--                        Le Plateau (Sartrouville)-->
                <!--                      </label>-->
                <!--                    </div>-->
                <!--                    <div class="form-check collapse" id="quartier2">-->
                <!--                      <input class="form-check-input" type="checkbox" value="" id="qpv3">-->
                <!--                      <label class="form-check-label font-size-1" for="qpv3">-->
                <!--                        Le vieux pays (Sartrouville)-->
                <!--                      </label>-->
                <!--                    </div>-->

                <!--                    <div class="form-check">-->
                <!--                      <input class="form-check-input" type="checkbox">-->
                <!--                      <input class="form-check-label" type="text" placeholder="Autres quartiers ou villes concernées">-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                  &lt;!&ndash; End Form Group &ndash;&gt;-->

                <h6 v-if="budget_filter>1000" class="mt-4">Résultats attendus</h6>

                <label v-if="budget_filter>5000" for="indicateurs" class="col-sm-3 col-form-label input-label">Indicateurs
                  d'activité</label>

                <div v-if="budget_filter>5000" class="col-sm-9">

                  <div>
                    <div v-for="indicateur in aap.indicateurs" :key="indicateur.id"
                         class="card card-body card-bordered"
                         :id="'indicateur_' + indicateur.id">
                      <hr>
                      <input type="hidden" :name="'aap[aap_indicateurs_attributes][' + indicateur.id + '][id]'"
                             :id="'poste_id_' + indicateur.id" :value="indicateur.id">
                      <div class="row form-group ml-3">
                        <label for="'indicateur_indicateur_' + indicateur.id"
                               class="col-sm-3 col-form-label input-label">
                          Détail indicateur
                        </label>
                        <div class="col-sm-9">
                              <textarea rows="3" :id="'indicateur_' + indicateur.id" :value="indicateur.indicateur"
                                        :name="'aap[aap_indicateurs_attributes][' + indicateur.id + '][indicateur]'"
                                        placeholder="Description de l'indicateur"
                                        aria-label="Description de l'indicateur"
                                        class="form-control"></textarea>
                        </div>
                      </div>

                      <input value="false"
                             type="hidden"
                             :name="'aap[aap_indicateurs_attributes][' + indicateur.id + '][_destroy]'"
                             :id="'aap_indicateurs_attributes_' + indicateur.id">

                      <button type="button" class="btn btn-danger" :disabled="aap.status_id == 9"
                              @click="delete_element('aap_indicateurs_attributes_' + indicateur.id, 'indicateur_' + indicateur.id)">
                        <i class="fas fa-times">&nbsp; Supprimer</i>
                      </button>


                    </div>

                    <div class="card">
                      <div class="card-header bg-primary text-white p-2">
                        Ajouter un indicateur
                      </div>
                      <div class="card-body">
                        <div class="card card-body card-bordered" id="indicateur"
                             data-attribute="aap[aap_indicateurs_attributes]">
                          <div class="row form-group ml-3">
                            <label for="indicateur" class="col-sm-3 col-form-label input-label">
                              Détail indicateur
                            </label>
                            <div class="col-sm-9">
                              <textarea rows="3" id="indicateur" data-name="mission"
                                        name="aap[aap_indicateurs_attributes][0][indicateur]"
                                        v-model="new_indicateur_indicateur"
                                        placeholder="Description de l'indicateur" aria-label="Description n°1"
                                        class="form-control"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                    <i class="fas fa-plus"></i>
                  </a>

                </div>

                <label v-if="budget_filter>5000" for="indicateur_resultat" class="col-sm-3 col-form-label input-label">Indicateurs
                  de résultat</label>

                <div v-if="budget_filter>5000" class="col-sm-9">

                  <div>
                    <div v-for="indicateur in aap.indicateur_resultats" :key="indicateur.id"
                         class="card card-body card-bordered"
                         :id="'indicateur_resultat_' + indicateur.id">
                      <hr>
                      <input type="hidden" :name="'aap[aap_indicateur_resultats_attributes][' + indicateur.id + '][id]'"
                             :id="'poste_id_' + indicateur.id" :value="indicateur.id">
                      <div class="row form-group ml-3">
                        <label for="'indicateur_resultat_indicateur_' + indicateur.id"
                               class="col-sm-3 col-form-label input-label">
                          Détail indicateur de résultat
                        </label>
                        <div class="col-sm-9">
                              <textarea rows="3" :id="'indicateur_resultat_' + indicateur.id"
                                        :value="indicateur.indicateur"
                                        :name="'aap[aap_indicateur_resultats_attributes][' + indicateur.id + '][indicateur]'"
                                        placeholder="Description de l'indicateur"
                                        aria-label="Description de l'indicateur"
                                        class="form-control"></textarea>
                        </div>
                      </div>

                      <input value="false"
                             type="hidden"
                             :name="'aap[aap_indicateur_resultats_attributes][' + indicateur.id + '][_destroy]'"
                             :id="'aap_indicateur_resultats_attributes_' + indicateur.id">

                      <button type="button" class="btn btn-danger" :disabled="aap.status_id == 9"
                              @click="delete_element('aap_indicateur_resultats_attributes_' + indicateur.id, 'indicateur_resultat_' + indicateur.id)">
                        <i class="fas fa-times">&nbsp; Supprimer</i>
                      </button>


                    </div>

                    <div class="card">
                      <div class="card-header bg-primary text-white p-2">
                        Ajouter un indicateur de résultat
                      </div>
                      <div class="card-body">
                        <div class="card card-body card-bordered" id="indicateur_resultat"
                             data-attribute="aap[aap_indicateur_resultats_attributes]">
                          <div class="row form-group ml-3">
                            <label for="indicateur" class="col-sm-3 col-form-label input-label">
                              Détail indicateur
                            </label>
                            <div class="col-sm-9">
                              <textarea rows="3" id="indicateur" data-name="mission"
                                        name="aap[aap_indicateur_resultats_attributes][0][indicateur]"
                                        v-model="new_indicateur_resultat_indicateur"
                                        placeholder="Description de l'indicateur de résultat"
                                        aria-label="Description de l'indicateur de résultat"
                                        class="form-control"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                    <i class="fas fa-plus"></i>
                  </a>

                </div>

                <!-- resultats_trimestriels_estimes -->
                <!--                  <div data-progress="part4" class="row form-group ml-3">-->
                <!--                    <label for="resultats_trimestriels_estimes" class="col-sm-3 col-form-label input-label">-->
                <!--                      Résultats trimestriels estimés-->
                <!--                    </label>-->
                <!--                    <div class="col-sm-9">-->
                <!--                      <textarea rows="3" name="aap[resultats_trimestriels_estimes]" id="resultats_trimestriels_estimes"-->
                <!--                                placeholder="Résultat estimé" aria-label="Résultat estimé" class="form-control"-->
                <!--                                v-model="resultats_trimestriels_estimes"></textarea>-->
                <!--                    </div>-->
                <!--                  </div>-->

                <!-- impact_social -->
                <div v-if="budget_filter>1000" data-progress="part4" class="row form-group ml-3">
                  <label for="impact_social" class="col-sm-3 col-form-label input-label">
                    Impact social attendu du projet sur les bénéficiaires
                  </label>
                  <div class="col-sm-9">
                      <textarea rows="3" id="impact_social" name="aap[impact_social]" v-model="impact_social"
                                placeholder="Impacts ..." aria-label="Impacts ..." class="form-control"></textarea>
                  </div>
                </div>

                <h6 class="my-4">Quel public allez-vous toucher?</h6>

                <div id="tableau_public">
                  <table class="table table-primary table-bordered">
                    <thead class="thead-primary">
                    <tr>
                      <th scope="col" class="text-center" style="width: 14.3%;">Genre \ Age</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">- de 3 ans</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">4-10</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">11-17</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">18-24</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">25-65</th>
                      <th scope="col" class="text-center" style="width: 14.3%;">+ de 65 ans</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">Femmes</th>
                      <td>
                        <input type="number" name="aap[femmes_tranche_1]" placeholder="0" v-model="femmes_tranche_1"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[femmes_tranche_2]" placeholder="0" v-model="femmes_tranche_2"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[femmes_tranche_3]" placeholder="0" v-model="femmes_tranche_3"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[femmes_tranche_4]" placeholder="0" v-model="femmes_tranche_4"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[femmes_tranche_5]" placeholder="0" v-model="femmes_tranche_5"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[femmes_tranche_6]" placeholder="0" v-model="femmes_tranche_6"
                               min="0" step="1">
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Hommes</th>
                      <td>
                        <input type="number" name="aap[hommes_tranche_1]" placeholder="0" v-model="hommes_tranche_1"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[hommes_tranche_2]" placeholder="0" v-model="hommes_tranche_2"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[hommes_tranche_3]" placeholder="0" v-model="hommes_tranche_3"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[hommes_tranche_4]" placeholder="0" v-model="hommes_tranche_4"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[hommes_tranche_5]" placeholder="0" v-model="hommes_tranche_5"
                               min="0" step="1">
                      </td>
                      <td>
                        <input type="number" name="aap[hommes_tranche_6]" placeholder="0" v-model="hommes_tranche_6"
                               min="0" step="1">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="d-flex justify-content-center">
                  <div data-progress="part4" class="row form-group ml-3">
                    <label class="col-form-label input-label mr-3 font-weight-bold">
                      Nombre total de personnes touchées
                    </label>
                    <div>
                      <input readonly="readonly" type="number" id="publicTotal" placeholder="0" class="form-control"
                             v-model="public_total">
                    </div>
                  </div>
                </div>

                <h6 v-if="budget_filter>5000" class="my-4 ml-3">Typologie public</h6>

                <div v-if="budget_filter>5000" data-progress="part4" class="d-flex">
                  <div class="col-12 col-md-6">

                    <input type="hidden" name="aap[aap_public_ids][]" value="">

                    <div class="form-check" v-for="typologie in aap_publics" :key="typologie.id">
                      <input type="checkbox" :value="typologie.id" :id="'typologie_' + typologie.id"
                             name="aap[aap_public_ids][]"
                             :checked="Object.values(aap_public_ids).includes(typologie.id)"
                             class="form-check-input">
                      <label :for="'typologie_' + typologie.id" class="form-check-label font-size-1">
                        {{ typologie.nom }}
                      </label>
                    </div>

                  </div>
                </div>

                <hr data-scroll="5" class="my-6 mw-66 mx-auto">


                <h4 id="budget" class="my-4" style="scroll-margin-top: 140px;">Budget</h4>
                <div class="row form-group mt-4">

                  <label for="globalCostLabel" class="col-sm-3 col-form-label input-label">
                    Montant global du projet
                  </label>

                  <div data-progress="part5" class="col-sm-9">
                    <div class="input-group col-sm-9 px-0">
                      <input type="number" min="0" step="1"
                             name="aap[budget_global]" id="budget_global" placeholder="10000" aria-label="10000"
                             @keyup="check_budget_global()"
                             class="form-control" v-model="budget_global">
                      <div class="input-group-append">
                        <div class="input-group-text">€ (HT)</div>
                      </div>
                    </div>
                    <p id="budget_global_help_block" class="mt-2 alert"
                       v-bind:class="invalid_budget_global ? 'alert-danger' : 'alert-success' ">
                      Le budget global doit être au minimum de 1250€
                    </p>

                  </div>
                </div>

                <div class="row form-group">
                  <label for="subvention_sollicitee" class="col-sm-3 col-form-label input-label">
                    Montant de la subvention sollicitée pour le projet <strong>(max: {{ max_subvention }} )</strong>
                  </label>
                  <div data-progress="part5" class="col-sm-9">
                    <div class="input-group col-sm-9 px-0">
                      <input type="number"
                             name="aap[subvention_sollicitee]" id="subvention_sollicitee"
                             @keyup="check_subvention_sollicitee()"
                             v-model="subvention_sollicitee" min="1000" max="40000" step="1"
                             placeholder="10000" aria-label="10000" class="form-control">
                      <div class="input-group-append">
                        <div class="input-group-text">€ (HT)</div>
                      </div>
                    </div>
                    <p id="subvention_sollicitee_help_block" class="mt-2 alert"
                       v-bind:class="invalid_subvention_solicitee ? 'alert-danger' : 'alert-success' ">
                      Le montant de la subvention solicitée doit être compris entre 1000€ et 40000€. <br>
                      Il ne doit pas dépasser 80% du montant global du projet.
                    </p>
                  </div>
                </div>


                <div class="row form-group">
                  <label for="subvention_sollicitee" class="col-sm-3 col-form-label input-label">
                    Télécharger et remplissez votre budget
                  </label>
                  <div data-progress="part5" class="col-sm-9">
                    <div class="input-group col-sm-9 px-0">
                      <a class="btn btn-primary btn-sm my-2 mx-1" href="/modules/dlnkaap/files/budget.xlsx" download>Budget</a>
                      <!--                          <i class="fa-solid fa-file-excel"></i>&nbsp;budget-->
                      <p class="mt-2 alert alert-info">
                        Téléchargez et remplissez votre budget. Il vous sera demandé pour finaliser votre
                        demande de subvention.
                      </p>
                    </div>
                  </div>
                </div>


                <div class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">
                    Avez-vous besoin de bénévoles ?
                    <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                  </label>

                  <div data-progress="part5" class="col-sm-9 my-auto">
                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[benevoles]" id="benevoles_oui"
                             @change="toggleCollapse('#tiroir4');evalProg('part5')"
                             class="form-check-input" value="1" :checked="besoins_benevoles === true">
                      <label for="benevoles_oui" class="form-check-label">Oui</label>
                    </div>

                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[benevoles]" id="benevoles_non"
                             @change="toggleCollapse('#tiroir4', false);evalProg('part5')"
                             class="form-check-input" value="0" :checked="besoins_benevoles != true">
                      <label for="benevoles_non" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>

                <div id="tiroir4" class="collapse mb-4" v-bind:class="{ show: besoins_benevoles }">
                  <h6 class="mt-4 mb-4 ml-3">
                    Détaillez les missions à destination des bénévoles</h6>

                  <div>
                    <div v-for="benevole in aap.benevoles_projet" :key="benevole.id"
                         class="card card-body card-bordered"
                         :id="'benevole_' + benevole.id">
                      <hr>
                      <input type="hidden" :name="'aap[aap_benevoles_attributes][' + benevole.id + '][id]'"
                             :id="'poste_id_' + benevole.id" :value="benevole.id">
                      <div class="row form-group ml-3">
                        <label for="'benevole_mission_' + benevole.id" class="col-sm-3 col-form-label input-label">
                          Détail mission
                        </label>
                        <div class="col-sm-9">
                            <textarea rows="3" :id="'benevole_mission_' + benevole.id" :value="benevole.mission"
                                      :name="'aap[aap_benevoles_attributes][' + benevole.id + '][mission]'"
                                      placeholder="Description" aria-label="Description"
                                      class="form-control"></textarea>
                        </div>
                      </div>
                      <div class="row form-group ml-3">
                        <label for="benevole_nombre" class="col-sm-3 col-form-label input-label">
                          Nombre de bénévoles pour la mission</label>
                        <div class="col-sm-9">
                          <input type="number" :id="'benevole_nombre_' + benevole.id" :value="benevole.nombre"
                                 placeholder="5" aria-label="5" class="form-control" min="0" step="1"
                                 :name="'aap[aap_benevoles_attributes][' + benevole.id + '][nombre]'">
                        </div>
                      </div>

                      <input value="false"
                             type="hidden"
                             :name="'aap[aap_benevoles_attributes][' + benevole.id + '][_destroy]'"
                             :id="'aap_benevoles_attributes_' + benevole.id">

                      <button type="button" class="btn btn-danger"
                              @click="delete_element('aap_benevoles_attributes_' + benevole.id, 'benevole_' + benevole.id)">
                        <i class="fas fa-times">&nbsp; Supprimer</i>
                      </button>


                    </div>

                    <div class="card">
                      <div class="card-header bg-primary text-white p-2">
                        Ajouter une mission
                      </div>
                      <div class="card-body">
                        <div class="card card-body card-bordered" id="benevole"
                             data-attribute="aap[aap_benevoles_attributes]">
                          <div class="row form-group ml-3">
                            <label for="benevole_mission" class="col-sm-3 col-form-label input-label">
                              Détail mission
                            </label>
                            <div class="col-sm-9">
                            <textarea rows="3" id="benevole_mission" data-name="mission"
                                      name="aap[aap_benevoles_attributes][0][mission]" v-model="new_benevole_mission"
                                      placeholder="Description n°1" aria-label="Description n°1"
                                      class="form-control"></textarea>
                            </div>
                          </div>
                          <div class="row form-group ml-3">
                            <label for="benevole_nombre" class="col-sm-3 col-form-label input-label">
                              Nombre de bénévoles pour la mission</label>
                            <div class="col-sm-9">
                              <input type="number" id="benevole_nombre" data-name="nombre" min="0" step="1"
                                     placeholder="5" aria-label="5" class="form-control" v-model="new_benevole_nombre"
                                     name="aap[aap_benevoles_attributes][0][nombre]">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <a href="javascript:" class="btn btn-primary" @click="post_structure()">
                    <i class="fas fa-plus"></i>
                  </a>
                </div>


                <div class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">
                    Avez-vous besoin de matériel ?
                    <i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                  </label>
                  <div data-progress="part5" class="col-sm-9 my-auto">
                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[besoins_materiels]" id="besoins_materiels_oui"
                             @change="toggleCollapse('#tiroir5');evalProg('part5')" value="1"
                             class="form-check-input" :checked="besoins_materiels === true">
                      <label
                          for="besoins_materiels_oui" class="form-check-label">
                        Oui
                      </label></div>
                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[besoins_materiels]" id="besoins_materiels_non" value="0"
                             @change="toggleCollapse('#tiroir5', false);evalProg('part5')"
                             class="form-check-input" :checked="besoins_materiels != true">
                      <label
                          for="besoins_materiels_non" class="form-check-label">
                        Non
                      </label>
                    </div>
                  </div>
                </div>

                <div id="tiroir5" class="collapse mb-4" v-bind:class="{ show: besoins_materiels }">
                  <h6 class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                  <div class="card card-body card-bordered">
                    <div class="row form-group ml-3">
                      <label for="materiels" class="col-sm-3 col-form-label input-label">Explications</label>
                      <div class="col-sm-9">
                          <textarea rows="3" name="aap[materiels]" id="materiels" v-model="materiels"
                                    placeholder="Description n°1" aria-label="Description n°1"
                                    class="form-control"></textarea></div>
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">
                    Avez-vous besoin de locaux ?<i aria-hidden="true" class="fa fa-arrow-down ml-2 text-primary"></i>
                  </label>
                  <div data-progress="part5" class="col-sm-9 my-auto">
                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[besoins_locaux]" id="besoins_locaux_oui"
                             @change="toggleCollapse('#tiroir7');evalProg('part5')"
                             class="form-check-input" value="1" :checked="besoins_locaux === true">
                      <label for="besoins_locaux_oui" class="form-check-label">Oui</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input type="radio" name="aap[besoins_locaux]" id="besoins_locaux_non"
                             @change="toggleCollapse('#tiroir7', false);evalProg('part5')"
                             class="form-check-input" value="0" :checked="besoins_locaux != true">
                      <label for="besoins_locaux_non" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>

                <div id="tiroir7" class="collapse mb-4" v-bind:class="{ show: besoins_locaux }"><h6
                    class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                  <div class="card card-body card-bordered">
                    <div class="row form-group ml-3">
                      <label for="locaux" class="col-sm-3 col-form-label input-label">Explications</label>
                      <div class="col-sm-9">
                          <textarea rows="3" name="aap[locaux]" id="locaux" placeholder="Description n°1"
                                    v-model="locaux"
                                    aria-label="Description n°1" class="form-control"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row form-group">
                  <label class="col-sm-3 col-form-label input-label">
                    Avez-vous besoin d'une expertise dans un domaine ?<i aria-hidden="true"
                                                                         class="fa fa-arrow-down ml-2 text-primary"></i>
                  </label>
                  <div class="col-sm-9 my-auto">
                    <div class="form-check form-check-inline">
                      <input type="radio" name="besoins_expertise" id="besoins_expertise_oui"
                             @change="toggleCollapse('#tiroir8')"
                             class="form-check-input" value="1" :checked="besoins_expertise === true">
                      <label for="besoins_expertise_oui" class="form-check-label">Oui</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input type="radio" name="besoins_expertise" id="besoins_expertise_non"
                             @change="toggleCollapse('#tiroir8', false);"
                             class="form-check-input" value="0" :checked="besoins_expertise != true">
                      <label for="besoins_expertise_non" class="form-check-label">Non</label>
                    </div>
                  </div>
                </div>

                <div id="tiroir8" class="collapse mb-4" v-bind:class="{ show: besoins_expertise }"><h6
                    class="mt-4 mb-4 ml-3">Détaillez votre besoin</h6>
                  <div class="card card-body card-bordered">
                    <div class="row form-group ml-3">
                      <label for="expertise" class="col-sm-3 col-form-label input-label">Explications</label>
                      <div class="col-sm-9">
                          <textarea rows="2" name="" id="expertise" placeholder="Description n°1"
                                    v-model="expertise"
                                    aria-label="Description n°1" class="form-control"></textarea>
                      </div>
                    </div>
                  </div>
                </div>


                <hr class="my-6 mw-66 mx-auto">
                <h6 class="mb-4">Informations complémentaires</h6>
                <div class="row form-group">
                  <label for="infos_complementaires" class="col-sm-3 col-form-label input-label">
                    Avez-vous des informations complémentaires à ajouter?
                  </label>
                  <div class="col-sm-9">
                      <textarea rows="3" name="aap[infos_complementaires]" id="infos_complementaires"
                                placeholder="Informations complémentaires" aria-label="Informations complémentaires"
                                v-model="infos_complementaires" class="form-control"></textarea>
                  </div>
                </div>
              </div>
              <div id="stickyBlockEndPoint"></div>

              <div class="card-footer d-flex justify-content-end">
                <button href="javascript:" class="btn btn-primary h-100" @click="post_structure()"
                        :disabled="aap.status_id == 9">Sauvegarder
                </button>
                <span class="mx-2"></span>
                <button href="javascript:" class="btn btn-primary ml-2" data-toggle="modal"
                        :disabled="aap.status_id == 9"
                        data-target="#validation_formulaire">Terminer
                </button>
                <span class="mx-2"></span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="validation_formulaire" tabindex="-1" role="dialog"
           aria-labelledby="validation_formulaireLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Validation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="font-size-1">Vous êtes sur le point de valider votre projet. Vous pouvez encore le modifier
                mais il changera de statut d'avancement.</p>
              <p class="font-size-1">Êtes-vous sûr ?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Non</button>
              <button type="button" class="btn btn-success" data-dismiss="modal" @click="goto_step('validation')">Oui
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-bind:class="(step === 'structure' || step === 'projet') ? 'd-none' : '' "
           class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10">

        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3 mb-lg-5">
              <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h3 class="mb-0">Validation</h3>
                  <a href="javascript:" class="btn btn-primary h-100" @click="goto_step('structure')">Retour</a>
                </div>
              </div>
              <div>
                <div class="card-body">


                  <div class="overflow-hidden space-top-lg-3 space-bottom-lg-1 bg-soft-primary">
                    <div class="position-relative">
                      <div class="container-fluid space-2 space-lg-0">
                        <div class="row justify-content-sm-center align-items-lg-center text-center">
                          <div class="col-lg-4 d-none d-lg-block">
                            <div data-aos="fade-up">
                              <!-- Device Mockup -->
                              <!--                              <div class="transform-rotate-3">-->
                              <!--                                <div class="device device-ipad">-->
                              <!--                                  <img class="device-ipad-frame" src="/modules/dlnkaap/img/components/ipad.svg" alt="Image Description">-->
                              <!--                                  <img class="device-ipad-screen" src="/modules/dlnkaap/img/il_est_content.jpg" alt="Image Description">-->
                              <!--                                </div>-->
                              <!--&lt;!&ndash;&ndash;&gt;-->
                              <!--                                <figure class="max-w-19rem w-100 position-absolute bottom-0 right-0 z-index-n1 mr-n8 mb-n5">-->
                              <!--                                  <img class="img-fluid" src="/modules/dlnkaap/img/components/dots-2.svg" alt="Image Description">-->
                              <!--                                </figure>-->
                              <!--                              </div>-->
                              <!-- End Device Mockup -->
                            </div>
                          </div>

                          <div class="col-sm-8 col-lg-4">
                            <!-- Title -->
                            <div class="mb-5">
                              <h2 class="my-3">Félicitation votre formulaire est rempli !</h2>
                              <hr class="border-dark">
                              <h3 class="my-3">Vous pouvez maintenant <br> télécharger le <a
                                  target="_blank"
                                  :href="'/module/dlnkaap/formulaire_pdf?aap_id=' + id_aap">PDF
                                <img class="avatar-sm" src="/modules/dlnkaap/img/pdf.png"></a>
                              </h3>
                              <p class="h4 text-primary my-3">Pour finaliser votre demande, déposez ce PDF sur le
                                portail des
                                subventions</p>
                              <a class="btn btn-block btn-primary my-3"
                                 href="https://partenaires.yvelines.fr/Extranet/extranet/login">Allez au portail</a>
                              <h4>Gardons le contact, ZeLink est la solution pour trouver des partenaires, de l'aide et
                                vous accompagner dans votre projet.</h4>
                            </div>
                            <!-- End Title -->
                          </div>

                          <div class="col-lg-4 d-none d-lg-block">
                            <div data-aos="fade-up" data-aos-delay="200">
                              <!-- Device Mockup -->
                              <!--                              <div class="max-w-33rem w-100 transform-rotate-2 ml-auto">-->
                              <!--                                <div class="device device-iphone-x">-->
                              <!--                                  <img class="device-iphone-x-frame" src="/modules/dlnkaap/img/components/iphone-x.svg" alt="Image Description">-->
                              <!--                                  <img class="device-iphone-x-screen" src="/modules/dlnkaap/img/elle_est_contente.jpg" alt="Image Description">-->
                              <!--                                </div>-->
                              <!--&lt;!&ndash;&ndash;&gt;-->
                              <!--                                <figure class="max-w-19rem w-100 position-absolute top-0 left-0 z-index-n1 mt-n5 ml-n5">-->
                              <!--                                  <img class="img-fluid" src="/modules/dlnkaap/img/components/dots-2.svg" alt="Image Description">-->
                              <!--                                </figure>-->
                              <!--                              </div>-->
                              <!-- End Device Mockup -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="d-none d-lg-block bg-light content-centered-y w-100 h-75 z-index-n1"></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>


    <div class="border-1" style="position: fixed; bottom: 50%; right:20px; z-index: 10">
      <div class="card bg-info p-2">
        <p class="text-center mb-2">Dernière modification : </p>
        <p class="text-center mb-2">Il y a : <span class="font-weight-bold">{{ timeSinceLastSave }}</span></p>
        <a href="javascript:" class="btn btn-primary h-100" @click="post_structure()">
          <span v-if="aap.status_id == 9">Sauvegarder le bilan</span>
          <span v-else>Sauvegarder</span>
        </a>
      </div>
    </div>

    <div v-if="aap_id==0" class="modal fade" id="cgs_modal" tabindex="-1" role="dialog" aria-labelledby="modal_cgs"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal_cgs">Création de compte</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>En validant cette partie du formulaire, vous consentez aux CGS et à créer un compte sur la plateforme
              ZeLink qui sera lié au numéro de SIRET.</p>
            <p>Voulez-vous confirmer ?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Refuser</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="goto_step('projet', true)">
              Confirmer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

export default {
  props: ['aap_id'],
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aap: "",
      aap_communes: Array,
      aap_tags: Array,
      aap_quartiers: Array,
      aap_publics: Array,

      step: String,

      budget_filter: 0,

      new_etape_date: Date,
      new_etape_description: String,
      new_etape_etape: String,
      new_activite_description: String,
      new_activite_activite: String,
      new_intervenant_nombre: Number,
      new_intervenant_fonction: String,
      new_objectif_objectif: String,
      new_objectif_description: String,
      new_objectif_risque: String,
      new_poste_montant: Number,
      new_poste_nom: Number,
      new_benevole_nombre: Number,
      new_benevole_mission: String,
      new_co_financement_nom: String,
      new_co_financement_montant: Number,
      new_financement_attente_nom: String,
      new_financement_attente_montant: Number,
      new_financement_attente_date: Date,
      new_coporteur_nom: String,
      new_coporteur_co_finance: Number,

      new_indicateur: String,
      new_indicateur_indicateur: String,
      new_indicateur_resultat: String,
      new_indicateur_resultat_indicateur: String,


      siret: String,
      siret_details: Object,

      invalid_siret: false,
      valid_siret: false,
      invalid_code_postal: Boolean,
      invalid_ville: Boolean,
      invalid_adresse: Boolean,
      invalid_date_immatriculation: Boolean,
      invalid_telephone: Boolean,
      invalid_email: Boolean,
      invalid_site_web: Boolean,
      invalid_statut_juridique: Boolean,
      invalid_asso_president: Boolean,
      invalid_asso_adresse: Boolean,
      invalid_asso_code_postal: Boolean,
      invalid_asso_ville: Boolean,
      invalid_asso_utiliste_public: Boolean,
      invalid_activite_principale: Boolean,
      invalid_contact_email: Boolean,
      invalid_taille_structure: Boolean,
      invalid_taille_salarie: Boolean,
      invalid_candidat_nom: Boolean,
      invalid_candidat_telephone: Boolean,
      invalid_candidat_fonction: Boolean,
      invalid_candidat_service: Boolean,
      invalid_candidat_email: Boolean,
      invalid_candidat_projet_deux_annees_precedentes_coporte_detail: Boolean,
      invalid_axe: Boolean,
      invalid_date_debut: Boolean,
      invalid_date_fin: Boolean,
      invalid_origine: Boolean,
      invalid_presentation: Boolean,
      invalid_evenements_ponctuel: Boolean,
      invalid_activites_annuelles: Boolean,
      invalid_ateliers_activite: Boolean,
      invalid_nombre_cdi: Boolean,
      invalid_nombre_cdi_etp: Boolean,
      invalid_nombre_cdd: Boolean,
      invalid_nombre_cdd_etp: Boolean,
      invalid_nombre_precaire: Boolean,
      invalid_nombre_precaire_etp: Boolean,
      invalid_nombre_contrat_aides: Boolean,
      invalid_nombre_contrat_aides_etp: Boolean,
      invalid_nombre_benevoles: Boolean,
      invalid_nombre_benevoles_etp: Boolean,
      invalid_nombre_fonctionnaires: Boolean,
      invalid_nombre_fonctionnaires_etp: Boolean,
      invalid_projet_objectif: Boolean,
      invalid_indicateurs: Boolean,
      invalid_unites_mesure: Boolean,
      invalid_impact_social: Boolean,
      invalid_femmes_tranche_1: Boolean,
      invalid_hommes_tranche_1: Boolean,
      invalid_femmes_tranche_2: Boolean,
      invalid_hommes_tranche_2: Boolean,
      invalid_femmes_tranche_3: Boolean,
      invalid_hommes_tranche_3: Boolean,
      invalid_femmes_tranche_4: Boolean,
      invalid_hommes_tranche_4: Boolean,
      invalid_femmes_tranche_5: Boolean,
      invalid_hommes_tranche_5: Boolean,
      invalid_femmes_tranche_6: Boolean,
      invalid_hommes_tranche_6: Boolean,
      invalid_subvention_solicitee: Boolean,
      invalid_budget_global: Boolean,

      id_aap: Number,
      logo_structure: "",
      photo_porteur: String,
      projet_illustration: String,
      nom: String,
      code_postal: String,
      ville: String,
      adresse: String,
      date_immatriculation: String,
      telephone: String,
      email: String,
      site_web: String,
      statut_juridique: String,
      asso_president: String,
      asso_adresse: String,
      asso_code_postal: String,
      asso_ville: String,
      asso_utilite_public: Boolean,
      activite_principale: String,
      contact_email: String,
      salaries: Boolean,
      status: String,
      taille_structure: String,
      candidat_nom: String,
      candidat_telephone: String,
      candidat_fonction: String,
      candidat_service: String,
      candidat_email: String,
      actions_recentes: Boolean,
      actions_recentes_description: String,
      financeur_recent: String,
      coporte_recent: Boolean,
      coporte_recent_description: String,
      axe: String,
      projet_nom: String,
      date_debut: Date,
      date_fin: Date,
      origine: String,
      presentation: String,
      evenements_ponctuel: Number,
      activites_annuelles: Number,
      ateliers_activite: Number,
      nombre_cdi_etp: Number,
      nombre_cdi: Number,
      nombre_cdd: Number,
      nombre_cdd_etp: Number,
      nombre_precaire: Number,
      nombre_precaire_etp: Number,
      nombre_contrat_aides: Number,
      nombre_contrat_aides_etp: Number,
      nombre_benevoles: Number,
      nombre_benevoles_etp: Number,
      nombre_fonctionnaires: Number,
      nombre_fonctionnaires_etp: Number,
      nombre_autres: Number,
      nombre_autres_etp: Number,
      projet_objectif: String,
      indicateurs: Array,
      unites_mesure: String,
      aap_tag_ids: Array,
      aap_quartier_ids: Array,
      aap_public_ids: Array,
      aap_commune_ids: Array,
      impact_social: String,
      femmes_tranche_1: Number,
      hommes_tranche_1: Number,
      femmes_tranche_2: Number,
      hommes_tranche_2: Number,
      femmes_tranche_3: Number,
      hommes_tranche_3: Number,
      femmes_tranche_4: Number,
      hommes_tranche_4: Number,
      femmes_tranche_5: Number,
      hommes_tranche_5: Number,
      femmes_tranche_6: Number,
      hommes_tranche_6: Number,

      // Budget
      budget_global: Number,
      subvention_sollicitee: Number,
      max_subvention: Number,
      charges: Number,
      autre_financement: Number,
      cofinancements: Boolean,
      cofinancements_attentes: Boolean,

      // Informations complémentaires
      infos_complementaires: String,
      besoins_benevoles: Boolean,
      besoins_materiels: Boolean,
      besoins_locaux: Boolean,
      besoins_expertise: Boolean,
      besoins_financement: Boolean,
      benevoles: String,
      locaux: String,
      materiels: String,
      coporteur: Boolean,
      expertise: String,
      demande_financement: String,
      demande_financement_montant: Number,


      is_association: Boolean,

      timer: Number,
      timeSinceLastSave: String,
    }
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {

    this.id_aap = this.aap_id
    this.is_association = false

    this.step = 'structure'
    this.invalid_subvention_solicitee = true
    this.invalid_budget_global = true


    this.logo_structure = "/modules/dlnkaap/img/socialmedia.jpg"
    this.photo_porteur = "/modules/dlnkaap/img/shadow.jpg"
    this.projet_illustration = this.pseudoRandomImage(this.aap_id);
    this.siret = ""
    this.nom = ""
    this.code_postal = ""
    this.adresse = ""
    this.ville = ""
    this.telephone = ""
    this.email = ""
    this.site_web = ""
    this.statut_juridique = ""
    this.asso_president = ""
    this.asso_adresse = ""
    this.asso_code_postal = ""
    this.asso_ville = ""
    this.asso_utilite_public = ""
    this.activite_principale = ""
    this.contact_email = ""
    this.taille_structure = ""
    this.salaries = false
    this.status = ""
    this.candidat_nom = ""
    this.candidat_telephone = ""
    this.candidat_fonction = ""
    this.candidat_service = ""
    this.candidat_email = ""
    this.coporte_recent = false
    this.coporte_recent_description = ""
    this.actions_recentes = false
    this.actions_recentes_description = ""
    this.financeur_recent = ""
    this.axe = ""
    this.projet_nom = ""
    this.origine = ""
    this.presentation = ""
    this.evenements_ponctuel = 0
    this.activites_annuelles = 0
    this.ateliers_activite = 0
    this.nombre_cdi = 0
    this.nombre_cdi_etp = 0
    this.nombre_cdd = 0
    this.nombre_cdd_etp = 0
    this.nombre_precaire = 0
    this.nombre_precaire_etp = 0
    this.nombre_contrat_aides = 0
    this.nombre_contrat_aides_etp = 0
    this.nombre_benevoles = 0
    this.nombre_benevoles_etp = 0
    this.nombre_fonctionnaires = 0
    this.nombre_fonctionnaires_etp = 0
    this.nombre_autres = 0
    this.nombre_autres_etp = 0
    this.projet_objectif = ""
    this.indicateurs = ""
    this.aap_tag_ids = []
    this.aap_quartier_ids = []
    this.aap_public_ids = []
    this.aap_commune_ids = []
    this.unites_mesure = ""
    this.impact_social = ""
    this.femmes_tranche_1 = 0
    this.hommes_tranche_1 = 0
    this.femmes_tranche_2 = 0
    this.hommes_tranche_2 = 0
    this.femmes_tranche_3 = 0
    this.hommes_tranche_3 = 0
    this.femmes_tranche_4 = 0
    this.hommes_tranche_4 = 0
    this.femmes_tranche_5 = 0
    this.hommes_tranche_5 = 0
    this.femmes_tranche_6 = 0
    this.hommes_tranche_6 = 0

    // Budget
    this.budget_global = 0
    this.charges = 0
    this.autre_financement = 0
    this.max_subvention = 0
    this.subvention_sollicitee = 0
    this.cofinancements = 0
    this.cofinancements_attente = false


    this.infos_complementaires = ""
    this.besoins_materiels = false
    this.besoins_locaux = false
    this.besoins_benevoles = false
    this.besoins_expertise = false
    this.besoins_financement = false
    this.locaux = ""
    this.materiels = ""
    this.benevoles = ""
    this.expertise = ""
    this.demande_financement = ""
    this.demande_financement_montant = 0

    this.coporteur = false
    this.coporteur_nom = ""
    this.coporteur_site_internet = ""
    this.coporteur_co_finance = 0
    this.cofinancements = false

    this.budget_filter = 10000

    this.get_data()
    //setInterval(this.post_structure, 1200000)

    this.timer = Date.now();
    this.timeSinceLastSave = "Maintenant";
    // setInterval(this.get_Time_Last_Save, 60000);
  },

  computed: {

    class_content: function () {
      return {
        'd-none': this.step === 'projet' || this.step === 'validation',
        // 'container': this.aap.status_id != 9,
        // 'container-fluid': this.aap.status_id == 9,
        // CRO - BILAN
        // 'd-none': this.step === 'projet' || this.step === 'validation' || this.aap.status_id == 9,
        // 'container': 1 == 1
        // 'container': this.aap.status_id != 9,
        // 'container-fluid': this.aap.status_id == 9,
      }
    },

    public_total: function () {

      if (isNaN(parseInt(this.femmes_tranche_1, 10))) this.femmes_tranche_1 = 0
      if (isNaN(parseInt(this.femmes_tranche_2, 10))) this.femmes_tranche_2 = 0
      if (isNaN(parseInt(this.femmes_tranche_3, 10))) this.femmes_tranche_3 = 0
      if (isNaN(parseInt(this.femmes_tranche_4, 10))) this.femmes_tranche_4 = 0
      if (isNaN(parseInt(this.femmes_tranche_5, 10))) this.femmes_tranche_5 = 0
      if (isNaN(parseInt(this.femmes_tranche_6, 10))) this.femmes_tranche_6 = 0

      if (isNaN(parseInt(this.hommes_tranche_1, 10))) this.hommes_tranche_1 = 0
      if (isNaN(parseInt(this.hommes_tranche_2, 10))) this.hommes_tranche_2 = 0
      if (isNaN(parseInt(this.hommes_tranche_3, 10))) this.hommes_tranche_3 = 0
      if (isNaN(parseInt(this.hommes_tranche_4, 10))) this.hommes_tranche_4 = 0
      if (isNaN(parseInt(this.hommes_tranche_5, 10))) this.hommes_tranche_5 = 0
      if (isNaN(parseInt(this.hommes_tranche_6, 10))) this.hommes_tranche_6 = 0


      return parseInt(this.femmes_tranche_1, 10) + parseInt(this.femmes_tranche_2, 10) + parseInt(this.femmes_tranche_3, 10)
          + parseInt(this.femmes_tranche_4, 10) + parseInt(this.femmes_tranche_5, 10) + parseInt(this.femmes_tranche_6, 10)
          + parseInt(this.hommes_tranche_1, 10) + parseInt(this.hommes_tranche_2, 10) + parseInt(this.hommes_tranche_3, 10)
          + parseInt(this.hommes_tranche_4, 10) + parseInt(this.hommes_tranche_5, 10) + parseInt(this.hommes_tranche_6, 10)

    },

    total_personne: function () {

      if (isNaN(parseInt(this.nombre_cdi, 10))) this.nombre_cdi = 0
      if (isNaN(parseInt(this.nombre_cdd, 10))) this.nombre_cdd = 0
      if (isNaN(parseInt(this.nombre_precaire, 10))) this.nombre_precaire = 0
      if (isNaN(parseInt(this.nombre_contrat_aides, 10))) this.nombre_contrat_aides = 0
      if (isNaN(parseInt(this.nombre_benevoles, 10))) this.nombre_benevoles = 0
      if (isNaN(parseInt(this.nombre_fonctionnaires, 10))) this.nombre_fonctionnaires = 0
      if (isNaN(parseInt(this.nombre_autres, 10))) this.nombre_autres = 0


      return parseInt(this.nombre_cdi, 10) + parseInt(this.nombre_cdd, 10) + parseInt(this.nombre_precaire, 10)
          + parseInt(this.nombre_contrat_aides, 10) + parseInt(this.nombre_benevoles, 10) + parseInt(this.nombre_fonctionnaires, 10)
          + parseInt(this.nombre_autres, 10)
    },

    total_etp: function () {

      if (isNaN(parseInt(this.nombre_cdi_etp, 10))) this.nombre_cdi_etp = 0
      if (isNaN(parseInt(this.nombre_cdd_etp, 10))) this.nombre_cdd_etp = 0
      if (isNaN(parseInt(this.nombre_precaire_etp, 10))) this.nombre_precaire_etp = 0
      if (isNaN(parseInt(this.nombre_contrat_aides_etp, 10))) this.nombre_contrat_aides_etp = 0
      if (isNaN(parseInt(this.nombre_benevoles_etp, 10))) this.nombre_benevoles_etp = 0
      if (isNaN(parseInt(this.nombre_fonctionnaires_etp, 10))) this.nombre_fonctionnaires_etp = 0
      if (isNaN(parseInt(this.nombre_autres_etp, 10))) this.nombre_autres_etp = 0


      let total = parseFloat(this.nombre_cdi_etp) + parseFloat(this.nombre_cdd_etp) + parseFloat(this.nombre_precaire_etp)
          + parseFloat(this.nombre_contrat_aides_etp) + parseFloat(this.nombre_benevoles_etp)
          + parseFloat(this.nombre_fonctionnaires_etp) + parseFloat(this.nombre_autres_etp)

      return total.toFixed(1)
    }

  },

  watch: {

    date_immatriculation: function (new_val) {

    },

    statut_juridique: function (new_val) {
      const _this = this;
      if (new_val === 'Association') {
        _this.is_association = true
        $('#asso_details').collapse('show');
      } else {
        _this.is_association = false
        $('#asso_details').collapse('hide');
      }
    },
  },

  methods: {
    handleScroll: function (event) {
      let part = 1;
      let topLimit = document.getElementById("spy_header").getBoundingClientRect().bottom;
      document.querySelectorAll('[data-scroll]').forEach(
          function (elem) {
            if ((elem.getBoundingClientRect().y - topLimit) / (window.innerHeight - topLimit) <= 0.4) {
              part = Math.max(parseInt(elem.getAttribute('data-scroll')), part);
            }
          }
      )
      let allparts = [];
      allparts.push(document.querySelector("[data-parts = porteur_button]"));
      allparts.push(document.querySelector("[data-parts = projet_button]"));
      allparts.push(document.querySelector("[data-parts = deroulement_button]"));
      allparts.push(document.querySelector("[data-parts = obj_button]"));
      allparts.push(document.querySelector("[data-parts = budget_button]"));

      allparts.forEach(elem => elem.id = "");

      allparts[part - 1].id = "currentPart";

    },

    close_message: function () {
      this.message = null;
    },

    delete_element: function (control_target, div_target) {
      document.getElementById(div_target).style.display = "none";
      document.getElementById(control_target).value = "true";
    },

    get_data: async function () {
      const _this = this;

      _this.new_etape_date = ""
      _this.new_etape_indicateur = ""
      _this.new_etape_description = ""
      _this.new_etape_etape = ""
      _this.new_indicateur_indicateur = ""
      _this.new_indicateur_resultat_indicateur = ""
      _this.new_activite_description = ""
      _this.new_activite_activite = ""
      _this.new_intervenant_nombre = null
      _this.new_intervenant_fonction = ""
      _this.new_objectif_objectif = ""
      _this.new_objectif_description = ""
      _this.new_objectif_risque = ""
      _this.new_poste_montant = null
      _this.new_poste_nom = ""
      _this.new_benevole_nombre = null
      _this.new_benevole_mission = ""
      _this.new_co_financement_nom = ""
      _this.new_co_financement_montant = null

      _this.new_financement_attente_nom = ""
      _this.new_financement_attente_date = ""
      _this.new_financement_attente_montant = null

      _this.new_coporteur_nom = ""
      _this.new_coporteur_co_finance = null

      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_tags.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      _this.telephone = customer.mobile_phone
      _this.email = customer.email
      _this.asso_president = `${customer.firstname} ${customer.lastname}`
      _this.candidat_nom = `${customer.firstname} ${customer.lastname}`
      _this.candidat_telephone = customer.mobile_phone
      _this.candidat_email = customer.email

      axios.get(api_url)
          .then(function (response) {
            _this.aap_tags = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );


      [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "aap_quartiers.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_quartiers = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

      [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aap_communes.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_communes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );


      if (_this.aap_id > 0) {
        [secure_key, customer_id, api_url] = await get_token_2()
        const api_base_url = api_url
        api_url += `aaps/${_this.aap_id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.aap = response.data.aap
              if (_this.aap.status_id == 9) {
                $("#candidature_form_content :input").attr("disabled", true);
              }
              const aap = _this.aap
              _this.axe = aap.axe

              // ******************* STRUCTURE *******************
              //
              _this.siret = aap.siret
              _this.date_immatriculation = aap.date_immatriculation
              _this.nom = aap.nom
              _this.telephone = aap.telephone
              _this.email = aap.email
              _this.ville = aap.ville
              _this.code_postal = aap.code_postal
              _this.adresse = aap.adresse
              _this.site_web = aap.site_web
              _this.statut_juridique = aap.statut_juridique
              _this.asso_president = aap.asso_president
              _this.asso_adresse = aap.asso_adresse
              _this.asso_ville = aap.asso_ville
              _this.asso_code_postal = aap.asso_code_postal
              _this.asso_utilite_public = aap.asso_utilite_public
              _this.taille_structure = aap.taille_structure
              _this.contact_email = aap.contact_email
              _this.activite_principale = aap.activite_principale
              _this.salaries = aap.salaries
              _this.status = aap.status
              // _this.budget_filter = aap.budget_global

              if (typeof (aap.logo_structure) != 'undefined') {
                _this.logo_structure = aap.logo_structure
              }

              // ******************* PROJET *******************
              //
              _this.candidat_nom = aap.candidat_nom
              if (typeof (aap.photo_porteur) != 'undefined') {
                _this.photo_porteur = aap.photo_porteur
              }

              _this.candidat_fonction = aap.candidat_fonction
              _this.candidat_service = aap.candidat_service
              _this.candidat_telephone = aap.candidat_telephone
              _this.candidat_email = aap.candidat_email
              _this.actions_recentes = aap.actions_recentes
              _this.actions_recentes_description = aap.actions_recentes_description
              _this.financeur_recent = aap.financeur_recent
              _this.coporte_recent = aap.coporte_recent
              _this.coporte_recent_description = aap.coporte_recent_description
              _this.projet_nom = aap.projet_nom
              _this.date_debut = aap.date_debut
              _this.date_fin = aap.date_fin
              _this.origine = aap.origine
              _this.presentation = aap.presentation

              _this.aap_tag_ids = aap.tag_ids
              _this.aap_quartier_ids = aap.quartier_ids
              _this.aap_public_ids = aap.public_ids
              _this.aap_commune_ids = aap.commune_ids

              // Projet
              //
              if (typeof (aap.projet_illustration) != 'undefined') {
                _this.projet_illustration = aap.projet_illustration
              }

              // Déroulement
              //
              _this.evenements_ponctuel = aap.evenements_ponctuel
              _this.activites_annuelles = aap.activites_annuelles
              _this.ateliers_activite = aap.ateliers_activite
              _this.nombre_cdi = aap.nombre_cdi
              _this.nombre_cdi_etp = aap.nombre_cdi_etp
              _this.nombre_cdd = aap.nombre_cdd
              _this.nombre_cdd_etp = aap.nombre_cdd_etp
              _this.nombre_precaire = aap.nombre_precaire
              _this.nombre_precaire_etp = aap.nombre_precaire_etp
              _this.nombre_contrat_aides = aap.nombre_contrat_aides
              _this.nombre_contrat_aides_etp = aap.nombre_contrat_aides_etp
              _this.nombre_benevoles = aap.nombre_benevoles
              _this.nombre_benevoles_etp = aap.nombre_benevoles_etp
              _this.nombre_fonctionnaires = aap.nombre_fonctionnaires
              _this.nombre_fonctionnaires_etp = aap.nombre_fonctionnaires_etp
              _this.nombre_autres = aap.nombre_autres
              _this.nombre_autres_etp = aap.nombre_autres_etp

              // Objectif
              //
              _this.projet_objectif = aap.projet_objectif


              // Résultat attendus
              _this.impact_social = aap.impact_social

              //  Quel public allez-vous toucher?
              _this.femmes_tranche_1 = aap.femmes_tranche_1
              _this.hommes_tranche_1 = aap.hommes_tranche_1
              _this.femmes_tranche_2 = aap.femmes_tranche_2
              _this.hommes_tranche_2 = aap.hommes_tranche_2
              _this.femmes_tranche_3 = aap.femmes_tranche_3
              _this.hommes_tranche_3 = aap.hommes_tranche_3
              _this.femmes_tranche_4 = aap.femmes_tranche_4
              _this.hommes_tranche_4 = aap.hommes_tranche_4
              _this.femmes_tranche_5 = aap.femmes_tranche_5
              _this.hommes_tranche_5 = aap.hommes_tranche_5
              _this.femmes_tranche_6 = aap.femmes_tranche_6
              _this.hommes_tranche_6 = aap.hommes_tranche_6

              // Budget
              _this.budget_global = aap.budget_global
              _this.charges = aap.charges
              _this.autre_financement = aap.autre_financement
              _this.subvention_sollicitee = aap.subvention_sollicitee

              // Informations complémentaires
              _this.infos_complementaires = aap.infos_complementaires
              _this.besoins_locaux = aap.besoins_locaux
              _this.besoins_materiels = aap.besoins_materiels
              _this.besoins_benevoles = aap.besoins_benevoles
              _this.besoins_expertise = aap.besoins_expertise
              _this.besoins_financement = aap.besoins_financement
              _this.benevoles = aap.benevoles
              _this.locaux = aap.locaux
              _this.materiels = aap.materiels
              _this.expertise = aap.expertise
              // _this.demande_financement = aap.demande_financement
              // _this.demande_financement_montant = aap.demande_financement_montant

              _this.coporteur = aap.coporteur
              _this.cofinancements = aap.cofinancements
              _this.cofinancements_attente = aap.cofinancements_attente
              _this.coporteur_nom = aap.coporteur_nom
              _this.coporteur_site_internet = aap.coporteur_site_internet
              _this.coporteur_co_finance = aap.coporteur_co_finance

              _this.check_budget_global()
              _this.check_subvention_sollicitee()


            })
            .catch(function (error) {
              if (error.response) {
                _this.message = error
                _this.message_type = "alert-danger"
                const status = error.response.status

                if (status === 401) {
                  window.location.replace("/");
                }
              }
            })
            .then(function () {
                  // always executed
                }
            );
      }

      [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "aap_publics.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap_publics = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },

    goto_step: function (step, skip = false) {
      const _this = this
      if (!skip) {
        if (step === 'validation') {
          //On passe à la step validation : le statut est "rempli" (zéro)
          //this.status = "Rempli";
        } else if (this.step === 'structure' && step === 'projet' && _this.aap_id == 0) {
          //On passe de projet à structure
          $('#cgs_modal').modal('show');
          return;
        }
      }
      this.step = step
      this.post_structure()
    },

    siret_info: async function () {
      const _this = this

      if (_this.siret.length != 14) {
        _this.invalid_siret = true
        _this.valid_siret = false
        return false
      }

      let token = '61d5df33-b5bd-3b63-b4ae-decf903cf342'

      const api_url = "https://api.insee.fr/entreprises/sirene/V3/siret/" + _this.siret

      axios.get(api_url, {
        headers: {
          Authorization: 'Bearer ' + token //the token is a variable which holds the token
        }
      })
          .then(function (response) {
            _this.siret_details = response.data
            _this.nom = _this.siret_details.etablissement.uniteLegale.denominationUniteLegale
            _this.code_postal = _this.siret_details.etablissement.adresseEtablissement.codePostalEtablissement
            let numero_rue = _this.siret_details.etablissement.adresseEtablissement.numeroVoieEtablissement
            let type_voie = _this.siret_details.etablissement.adresseEtablissement.typeVoieEtablissement
            let rue = _this.siret_details.etablissement.adresseEtablissement.libelleVoieEtablissement
            _this.adresse = `${numero_rue} ${type_voie} ${rue}`
            _this.ville = _this.siret_details.etablissement.adresseEtablissement.libelleCommuneEtablissement
            _this.date_immatriculation = _this.siret_details.etablissement.uniteLegale.dateCreationUniteLegale
            _this.valid_siret = true
            _this.invalid_siret = false
          })
          .catch(function (error) {
            console.log(error)
            _this.valid_siret = false
            _this.invalid_siret = true

          })
          .then(function () {
                // always executed
              }
          );
    },

    set_logo_structure: function (img_url) {
      this.logo_structure = img_url
    },

    set_photo_porteur: function (img_url) {
      this.photo_porteur = img_url
    },

    set_projet_illustration: function (img_url) {
      this.projet_illustration = img_url
    },

    check_budget_global: function () {
      const _this = this
      const budget_global = parseInt(_this.budget_global, 10)

      if (isNaN(budget_global)) {
        _this.invalid_budget_global = true
        return
      }

      if (budget_global < 1250) {
        _this.invalid_budget_global = true
        return
      }

      _this.max_subvention = Math.trunc(budget_global * 80 / 100)
      _this.invalid_budget_global = false
      _this.check_subvention_sollicitee()
    },

    check_subvention_sollicitee: function () {
      const _this = this
      const subvention_sollicitee = parseInt(_this.subvention_sollicitee, 10)
      const budget_global = parseInt(_this.budget_global, 10)
      let max_subvention = 0

      if (isNaN(budget_global)) {
        this.invalid_budget_global = true
        this.invalid_subvention_solicitee = true
        return
      }

      if (isNaN(subvention_sollicitee)) {
        this.invalid_subvention_solicitee = true
        return
      }

      max_subvention = budget_global * 80 / 100

      if (subvention_sollicitee < 1000 || subvention_sollicitee > 40000 || subvention_sollicitee > max_subvention) {
        this.invalid_subvention_solicitee = true
        return
      }

      this.invalid_subvention_solicitee = false
      _this.check_budget_global()
    },

    post_bilan: async function () {
      const _this = this;
      _this.message = "Bilan enregistré";
      _this.message_type = "alert-success";
    },

    post_structure: async function () {

      this.timer = Date.now();
      this.get_Time_Last_Save();

      const _this = this;
      let method = ""

      let [secure_key, customer_id, api_url] = await get_token_2()

      if (_this.aap_id == 0 && _this.id_aap == 0) {
        method = 'post'
        api_url += "aaps.json"
      } else {
        method = 'patch'

        api_url += `aaps/${_this.id_aap}.json`
      }

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_data = new FormData();
      const form_element = document.getElementById("aap_form");
      const form_data = new FormData(form_element);

      form_data.append('logo_structure_base64', _this.logo_structure)
      form_data.append('photo_porteur_base64', _this.photo_porteur)
      form_data.append('projet_illustration_base64', _this.projet_illustration)
      form_data.append('step', _this.step)

      axios({
        method: method,
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Candidature enregistrée, retrouvez cette candidature dans \"Mes Candidatures\"";
            _this.message_type = "alert-success";
            _this.aap = response.data.aap
            _this.id_aap = _this.aap.id
            _this.get_data()
          })
          .catch(function (error) {
            console.log(error)

            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";
          });
    },

    get_Time_Last_Save: function () {
      let currentTime = parseInt(Date.now() - this.timer);
      if (currentTime < 60000)
        this.timeSinceLastSave = "Maintenant"
      else {
        currentTime = Math.round((currentTime / 1000) / 60);
        if (currentTime < 60)
          this.timeSinceLastSave = currentTime.toString() + " minute(s)"
        else
          this.timeSinceLastSave = Math.round(currentTime / 60).toString() + " heure(s)"
      }
    },

    toggleCollapse: function (collapsed, enable = true) {
      if (enable) {
        $(collapsed).collapse('show');
      } else {
        $(collapsed).collapse('hide');
      }
    },

    pseudoRandomImage: function (aap_id) {
      let random = 1 + (aap_id % 25);
      return "/themes/template/img/group/photo_groupe/" + random.toString() + ".jpg";
    },


  }

}
</script>

<style>
/* Chrome, Safari, Edge, Opera */
#budget_filtre input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#budget_filtre input[type=number] {
  -moz-appearance: textfield;
}
</style>